import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { map, pluck, take, switchMap, tap, debounceTime, takeUntil } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i3 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import * as i4 from 'ngx-toastr';
import * as i4$1 from 'app-services-library';
import * as i7 from '@angular/common';
import * as i6$4 from 'primeng/divider';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import { MarkDirtyFormAction } from 'dirty-check-store';
import * as i2$1 from '@angular/forms';
import { FormGroup, FormControl, Validators, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environment-configurations';
import * as i2 from 'primeng/dynamicdialog';
import * as i6 from 'primeng/dropdown';
import * as i8 from 'primeng/table';
import * as i11 from 'primeng/api';
import * as errorUtils from 'error-message-utility';
import { map as map$1 } from 'rxjs/internal/operators/map';
import * as i6$1 from 'primeng/inputtext';
import * as i10 from 'primeng/dialog';
import * as i11$1 from 'primeng/radiobutton';
import * as i12 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i6$2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i7$1 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i6$3 from 'primeng/tooltip';
import * as i8$1 from 'primeng/button';
import * as i12$1 from 'primeng/checkbox';
import { PrimengLibraryModule } from 'primeng-library';

class ListJobDutiesService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.duties$ = new BehaviorSubject([]);
        this.jobDescription$ = new BehaviorSubject(null);
    }
    getDuties() {
        return this.duties$.asObservable();
    }
    setDuties(d, append = true) {
        if (append) {
            this.duties$.next([...this.duties$.value, ...d]);
        }
        else {
            this.duties$.next(d);
        }
    }
    getJobDescription$() {
        return this.jobDescription$.asObservable();
    }
    setJobDescription$(value) {
        this.jobDescription$.next(value);
    }
    // selectedDuties$: BehaviorSubject<Array<any>> = new BehaviorSubject(null);
    // getSelectedDuties(): Observable<Array<any>> {
    //   return this.selectedDuties$.asObservable();
    // }
    // setSelectedDuties(d: Array<any>) {
    //   this.selectedDuties$.next(d);
    // }
    getJobDescription(visatype, caseType, caseId, isForeignCompany) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/jobDescription?isThisPastJob=${isForeignCompany}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    saveOnetDutySubDuty(inputData, payload) {
        return this.httpClient.post(`/${inputData.visatype}/${inputData.caseType}/${inputData.caseId}/saveDutyDetails`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
ListJobDutiesService.ɵfac = function ListJobDutiesService_Factory(t) { return new (t || ListJobDutiesService)(i0.ɵɵinject(i1.HttpClient)); };
ListJobDutiesService.ɵprov = i0.ɵɵdefineInjectable({ token: ListJobDutiesService, factory: ListJobDutiesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListJobDutiesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ImagilityJobDutiesService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getJobRoles(companyId) {
        return this.httpClient
            .get(`/company/${companyId}/masterData/jobRole`)
            .pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getJobCategoryList_ddl() {
        return this.httpClient
            .get(`/company/masterData/jobcategory`)
            .pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    getJobRolesList_ddl(categoryId, selectedCompany) {
        return this.httpClient
            .get(`/company/${selectedCompany.companyId}/category/${categoryId}/jobroles`)
            .pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    resetDefault(jobTitle) {
        return this.httpClient
            .get(`/company/${jobTitle}/reset/jobduties`)
            .pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    getJobRolesDuties(companyId, jobRoleId) {
        return this.httpClient
            .get(`/company/${companyId}/masterData/jobRole/${jobRoleId}`)
            .pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    getIOSMapping(visatype, caseType, caseId, positionId, dutyId) {
        return this.httpClient.get(`${environment.baseUrl}/${visatype}/${caseType}/${caseId}/position/${positionId}/duty/${dutyId}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
ImagilityJobDutiesService.ɵfac = function ImagilityJobDutiesService_Factory(t) { return new (t || ImagilityJobDutiesService)(i0.ɵɵinject(i1.HttpClient)); };
ImagilityJobDutiesService.ɵprov = i0.ɵɵdefineInjectable({ token: ImagilityJobDutiesService, factory: ImagilityJobDutiesService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImagilityJobDutiesService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function ImagilityJobDutiesComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "p", 15);
    i0.ɵɵtext(3, "Results populated from Imagility Library");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 16);
    i0.ɵɵtext(5, " Select the option you prefer. Click \"");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "Add to List");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, "\" and proceed. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 17);
    i0.ɵɵelementStart(10, "button", 9);
    i0.ɵɵlistener("click", function ImagilityJobDutiesComponent_div_15_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.addToList(); });
    i0.ɵɵtext(11, " Add to List ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ImagilityJobDutiesComponent_div_18_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 22);
    i0.ɵɵelementStart(1, "th", 23);
    i0.ɵɵelement(2, "p-tableHeaderCheckbox");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 24);
    i0.ɵɵtext(4, "Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 24);
    i0.ɵɵtext(6, "Sub-Duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ImagilityJobDutiesComponent_div_18_ng_template_3_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(s_r10.duty);
} }
function ImagilityJobDutiesComponent_div_18_ng_template_3_ul_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 28);
    i0.ɵɵtemplate(1, ImagilityJobDutiesComponent_div_18_ng_template_3_ul_6_li_1_Template, 2, 1, "li", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", eachDuty_r6 == null ? null : eachDuty_r6.subduty);
} }
function ImagilityJobDutiesComponent_div_18_ng_template_3_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "No Sub Duties present.");
    i0.ɵɵelementEnd();
} }
function ImagilityJobDutiesComponent_div_18_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 22);
    i0.ɵɵelementStart(1, "td", 23);
    i0.ɵɵelement(2, "p-tableCheckbox", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 24);
    i0.ɵɵtemplate(6, ImagilityJobDutiesComponent_div_18_ng_template_3_ul_6_Template, 2, 1, "ul", 26);
    i0.ɵɵtemplate(7, ImagilityJobDutiesComponent_div_18_ng_template_3_p_7_Template, 2, 0, "p", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", eachDuty_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(eachDuty_r6.duty);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", eachDuty_r6.subduty && eachDuty_r6.subduty.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachDuty_r6.subduty && eachDuty_r6.subduty.length == 0);
} }
const _c0$5 = function () { return { "min-width": "100%" }; };
function ImagilityJobDutiesComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "p-table", 19);
    i0.ɵɵlistener("selectionChange", function ImagilityJobDutiesComponent_div_18_Template_p_table_selectionChange_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.selectedDuties = $event; });
    i0.ɵɵtemplate(2, ImagilityJobDutiesComponent_div_18_ng_template_2_Template, 7, 0, "ng-template", 20);
    i0.ɵɵtemplate(3, ImagilityJobDutiesComponent_div_18_ng_template_3_Template, 8, 4, "ng-template", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r1.dutiesArr)("selection", ctx_r1.selectedDuties)("tableStyle", i0.ɵɵpureFunction0(3, _c0$5));
} }
const _c1$2 = function () { return { width: "100%" }; };
const deleteDialogConfigurations = {
    width: "30%",
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
};
class ImagilityJobDutiesComponent {
    constructor(apiService, dialogService, store, listOfDutiesService) {
        this.apiService = apiService;
        this.dialogService = dialogService;
        this.store = store;
        this.listOfDutiesService = listOfDutiesService;
        this.activateView = new EventEmitter();
        // observableSubscription$ = new Subject();
        this.categoryList = [];
        this.jobRoleOptions = [];
        this.dutiesArr = null;
        this.disabledControls = false;
        this.jobDutiesForm = new FormGroup({
            otherJobPosition: new FormControl(null),
            selectedCategory: new FormControl(null),
            jobRole: new FormControl(null),
            jobDutyForceDelete: new FormControl(null),
        });
    }
    ngOnInit() {
        this.loadCategory_ddl();
    }
    loadCategory_ddl() {
        this.apiService
            .getJobCategoryList_ddl()
            .pipe(take(1), map((res) => {
            this.categoryList = res;
            if (this.inputData && this.jobDutiesForm && this.inputData.jsonInput && this.inputData.jsonInput.jobCategory) {
                const selectedCategory = this.categoryList.find((cat) => cat.jobCategory === this.inputData.jsonInput.jobCategory);
                if (selectedCategory) {
                    this.jobDutiesForm.get('selectedCategory').patchValue(selectedCategory);
                    return ({ event: { value: { id: selectedCategory[0].id } }, categoryResponse: res });
                }
            }
            return ({ event: null, categoryResponse: res });
        }), switchMap(({ event, categoryResponse }) => !!event ? this.apiService.getJobRolesList_ddl(event, this.inputData).pipe(tap(jobRoleResponse => {
            this.onJobRolesSuccessReponse(jobRoleResponse);
        })) : of('')))
            .subscribe();
    }
    onChangeCategory(event) {
        this.apiService
            .getJobRolesList_ddl(event.value.id, this.inputData)
            .pipe(take(1))
            .subscribe((response) => {
            this.onJobRolesSuccessReponse(response);
        });
    }
    saveJobRoleOrPopulateDuties() {
        const jobRole = this.jobDutiesForm.get('jobRole').value;
        this.handleOnsaveJobRoleOrPopulateDuties({
            selectedJobPosition: jobRole,
            customPositionTitle: this.jobDutiesForm.get('otherJobPosition').value,
            selectedJobPositionId: this.jobRoleOptions.find(x => x.jobTitle === jobRole).id
        });
    }
    setPositionTitle({ value }) {
        sessionStorage.setItem("selectedJobRole", JSON.stringify(this.jobRoleOptions.find((item) => item.jobTitle == value)));
        if (value !== 'Other') {
            this.jobDutiesForm.controls['otherJobPosition'].setValue(null);
        }
    }
    populateJobDuties(input) {
        this.selectedDuties = [];
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true,
        }));
        this.apiService
            .getJobRolesDuties(this.inputData.companyId, input.selectedJobPositionId)
            .pipe(take(1))
            .subscribe((data) => {
            // Replaced with new logic
            // if (response && response.jobDuty && response.jobDuty.length > 0) {
            //   response.jobDuty.forEach((element) => {
            //     element["id"] = null;
            //     if (element.subduty && element.subduty.length > 0) {
            //       element.subduty.forEach((subJobDuty) => {
            //         subJobDuty["id"] = null;
            //       });
            //     }
            //     // TODO Replace this logic with populating in table
            //     // (this.jobDutiesForm.controls['duties'] as FormArray).push(this.buildDutyList(element));
            //   });
            // }
            if (data && data.jobDuty && data.jobDuty.length > 0) {
                this.dutiesArr = data.jobDuty.map(e => {
                    e.type = 'IMAGILITYLIB';
                    return e;
                });
            }
        });
    }
    // TODO if necessary
    // buildDutyList(item) {
    //   let subJobDuty = [];
    //   if (item.subJobDuty && item.subJobDuty.length > 0) {
    //     item.subJobDuty.forEach(element => {
    //       subJobDuty.push(this.buildSubDutyList(element));
    //     });
    //   }
    //   return this.fb.group({
    //     'id': item.id,
    //     'name': item.name,
    //     'subJobDuty': this.fb.array(subJobDuty)
    //   });
    // }
    buildSubDutyList(item) {
        // TODO if necessary
        // return this.jobDescriptionBuilder.group({
        //   id: item.id,
        //   name: item.duty || item.name
        // });
    }
    // ngOnDestroy() {
    //   this.observableSubscription$.next();
    //   this.observableSubscription$.complete();
    // }
    handleOnsaveJobRoleOrPopulateDuties(input) {
        // const overlppingReconfirmDialogRef = this.dialogService.open(
        //   DeleteDialogLibraryComponent,
        //   {
        //     ...deleteDialogConfigurations,
        //     data: {
        //       deleteMessage:
        //         "Do you wish to populate duties & sub duties? This will override any existing duties",
        //     },
        //   }
        // );
        // overlppingReconfirmDialogRef.onClose
        //   .pipe(take(1))
        //   .subscribe((response: boolean) => {
        //     if (response) {
        //       if (this.jobDutiesForm.value && this.jobDutiesForm.value.id) {
        //         this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType,
        //           this.inputData.caseId, this.jobDutiesForm.value.id, 0)
        //           .pipe(take(1))
        //           .subscribe((IOSMappingResponse) => {
        //             if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
        //               const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, {
        //                 ...deleteDialogConfigurations,
        //                 data: {
        //                   deleteMessage: 'Job duties cannot be populated as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
        //                 }
        //               });
        //               deleteReconfirmDialogRef.onClose
        //                 .pipe(take(1))
        //                 .subscribe((deleteReconfirmResponse: boolean) => {
        //                   if (deleteReconfirmResponse) {
        //                     this.jobDutiesForm.controls['jobDutyForceDelete'].setValue(true);
        //                     this.populateJobDuties(input);
        //                   }
        //                 });
        //             } else {
        //               this.populateJobDuties(input);
        //             }
        //           });
        //       } else {
        //         // if there is no position id exists. no need to check ios mapping exists
        //         this.populateJobDuties(input);
        //       }
        //     }
        //   });
        // New Implementation
        if (this.jobDutiesForm.value && this.jobDutiesForm.value.id) {
            this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.jobDutiesForm.value.id, 0)
                .pipe(take(1))
                .subscribe((IOSMappingResponse) => {
                if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
                    const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                            deleteMessage: 'Job duties cannot be populated as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
                        } }));
                    deleteReconfirmDialogRef.onClose
                        .pipe(take(1))
                        .subscribe((deleteReconfirmResponse) => {
                        if (deleteReconfirmResponse) {
                            this.jobDutiesForm.controls['jobDutyForceDelete'].setValue(true);
                            this.populateJobDuties(input);
                        }
                    });
                }
                else {
                    this.populateJobDuties(input);
                }
            });
        }
        else {
            // if there is no position id exists. no need to check ios mapping exists
            this.populateJobDuties(input);
        }
    }
    onJobRolesSuccessReponse(response) {
        if (response) {
            this.jobRoleOptions = response.filter((role) => role.jobTitle !== "Other");
            // this.selectedJobPosition = this.parentForm.get('jobRole').value === 'Other' ? 'Other' : this.parentForm.get('jobRole').value;
            let selectedJobRole;
            if (this.inputData && this.jobDutiesForm && this.inputData.jsonInput && this.inputData.jsonInput.jobRole) {
                selectedJobRole = this.jobRoleOptions.find((role) => role.jobTitle === this.inputData.jsonInput.jobRole);
            }
            if (!!selectedJobRole) {
                this.jobDutiesForm.get('jobRole').patchValue(selectedJobRole.jobTitle);
            }
            else {
                this.jobDutiesForm.get('jobRole').patchValue(null);
            }
        }
    }
    addToList() {
        let _duties = this.selectedDuties.map(e1 => {
            let _e1 = {};
            _e1.subJobDuty = e1.subduty.map(e2 => {
                let _e2 = {};
                _e2.id = null;
                _e2.name = e2.duty;
                return _e2;
            });
            _e1.id = null;
            _e1.name = e1.duty;
            return _e1;
        });
        this.listOfDutiesService.setDuties(_duties);
        this.activateView.emit('dutiesCart');
    }
}
ImagilityJobDutiesComponent.ɵfac = function ImagilityJobDutiesComponent_Factory(t) { return new (t || ImagilityJobDutiesComponent)(i0.ɵɵdirectiveInject(ImagilityJobDutiesService), i0.ɵɵdirectiveInject(i2.DialogService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(ListJobDutiesService)); };
ImagilityJobDutiesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ImagilityJobDutiesComponent, selectors: [["lib-imagility-job-duties"]], inputs: { inputData: "inputData" }, outputs: { activateView: "activateView" }, decls: 19, vars: 11, consts: [[1, "library-wrapper", 3, "formGroup"], [1, "library-title"], [1, "row"], [1, "col-md-4", "pl-0"], [1, "label-cls"], ["placeholder", "Select Category", "formControlName", "selectedCategory", "appendTo", "body", "optionLabel", "jobCategory", 3, "options", "disabled", "onChange"], [1, "col-md-4", "pl-0", "processing-dropdown"], ["id", "jobRolesId", "appendTo", "body", "optionLabel", "jobTitle", "optionValue", "jobTitle", "formControlName", "jobRole", "placeholder", "select", 3, "options", "filter", "disabled", "onChange"], [1, "col-md-4", "pl-0", "displayFlex", "align-bottom"], ["type", "button", 1, "im-btn", "im-btn-outline-primary", "button_whitebg", 3, "click"], ["class", "row results-wrapper", 4, "ngIf"], ["id", "imgLibrary", 1, "col-md-12", "p-0"], ["class", "library-table-wrapper", 4, "ngIf"], [1, "row", "results-wrapper"], [1, "col-md-8", "pl-0"], [1, "bold-title"], [1, "text-warning", "warn-caption"], [1, "col-md-4", "results-action-wrapper", "pr-0"], [1, "library-table-wrapper"], ["dataKey", "dutyId", 3, "value", "selection", "tableStyle", "selectionChange"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "dutyHeadPortion"], [1, "selectPortion"], [1, "dutyPortion"], [3, "value"], ["class", "sub-duties", 4, "ngIf"], [4, "ngIf"], [1, "sub-duties"], [4, "ngFor", "ngForOf"]], template: function ImagilityJobDutiesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "p", 1);
        i0.ɵɵtext(2, "Select category and position to generate prompt");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "label", 4);
        i0.ɵɵtext(6, " Job Category");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "p-dropdown", 5);
        i0.ɵɵlistener("onChange", function ImagilityJobDutiesComponent_Template_p_dropdown_onChange_7_listener($event) { return ctx.onChangeCategory($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "label", 4);
        i0.ɵɵtext(10, "Job Position");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "p-dropdown", 7);
        i0.ɵɵlistener("onChange", function ImagilityJobDutiesComponent_Template_p_dropdown_onChange_11_listener($event) { return ctx.setPositionTitle($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 8);
        i0.ɵɵelementStart(13, "button", 9);
        i0.ɵɵlistener("click", function ImagilityJobDutiesComponent_Template_button_click_13_listener() { return ctx.saveJobRoleOrPopulateDuties(); });
        i0.ɵɵtext(14, " Generate ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, ImagilityJobDutiesComponent_div_15_Template, 12, 0, "div", 10);
        i0.ɵɵelementStart(16, "div", 2);
        i0.ɵɵelementStart(17, "div", 11);
        i0.ɵɵtemplate(18, ImagilityJobDutiesComponent_div_18_Template, 4, 4, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.jobDutiesForm);
        i0.ɵɵadvance(7);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(10, _c1$2));
        i0.ɵɵproperty("options", ctx.categoryList)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.jobRoleOptions)("filter", false)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.dutiesArr && ctx.dutiesArr.length > 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.dutiesArr != null);
    } }, directives: [i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i6.Dropdown, i2$1.NgControlStatus, i2$1.FormControlName, i7.NgIf, i8.Table, i11.PrimeTemplate, i8.TableHeaderCheckbox, i8.TableCheckbox, i7.NgForOf], styles: [".displayFlex[_ngcontent-%COMP%]{display:flex}.warn-caption[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700}.align-bottom[_ngcontent-%COMP%]{align-items:end}.bold-title[_ngcontent-%COMP%]{font-weight:700;font-size:16px}.results-wrapper[_ngcontent-%COMP%]{margin-top:15px}.results-wrapper[_ngcontent-%COMP%]   .results-action-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:end;align-items:center}.warn-caption[_ngcontent-%COMP%]{font-size:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImagilityJobDutiesComponent, [{
        type: Component,
        args: [{
                selector: "lib-imagility-job-duties",
                templateUrl: "./imagility-job-duties.component.html",
                styleUrls: ["./imagility-job-duties.component.scss"],
            }]
    }], function () { return [{ type: ImagilityJobDutiesService }, { type: i2.DialogService }, { type: i3.Store }, { type: ListJobDutiesService }]; }, { inputData: [{
            type: Input
        }], activateView: [{
            type: Output
        }] }); })();

class OnetJobDuties {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getMajorGroupCodes(visaType, positionTitle) {
        var posTitle = positionTitle == null ? 'NULL' : this.toEncrypt(positionTitle);
        return this.httpClient.get(`/${visaType}/soc/majorGroup/position/title/${posTitle}`).pipe(map$1((response) => {
            if (response && response.status === 200) {
                return response.data;
            }
        }));
    }
    onetListItems(payload) {
        return this.httpClient.post(`/socduty/search`, payload).pipe(map$1((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getDutyListItems(payload) {
        return this.httpClient.post(`/getDutyList/${payload.petitionId}/${payload.pbPositionId}`, {}).pipe(map$1((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
OnetJobDuties.ɵfac = function OnetJobDuties_Factory(t) { return new (t || OnetJobDuties)(i0.ɵɵinject(i1.HttpClient)); };
OnetJobDuties.ɵprov = i0.ɵɵdefineInjectable({ token: OnetJobDuties, factory: OnetJobDuties.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OnetJobDuties, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0$4 = ["onetItem"];
function OnetJobDutiesComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", item_r6.majorGroup, "-", item_r6.majorGroupName, " ");
} }
function OnetJobDutiesComponent_div_17_mat_list_option_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-option", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r9, " ");
} }
function OnetJobDutiesComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵelementStart(3, "p", 27);
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5, "Job Duties Custom List");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 27);
    i0.ɵɵelementStart(7, "b");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 28);
    i0.ɵɵelementStart(10, "button", 29);
    i0.ɵɵlistener("click", function OnetJobDutiesComponent_div_17_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.showListDialog(); });
    i0.ɵɵtext(11, "Add to List");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 30);
    i0.ɵɵelementStart(13, "div", 1);
    i0.ɵɵelementStart(14, "mat-selection-list", 31, 32);
    i0.ɵɵlistener("selectionChange", function OnetJobDutiesComponent_div_17_Template_mat_selection_list_selectionChange_14_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.onSelectionChange(); });
    i0.ɵɵtemplate(16, OnetJobDutiesComponent_div_17_mat_list_option_16_Template, 2, 2, "mat-list-option", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 34);
    i0.ɵɵelementStart(18, "div", 35);
    i0.ɵɵelementStart(19, "button", 36);
    i0.ɵɵlistener("click", function OnetJobDutiesComponent_div_17_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.showListDialog(); });
    i0.ɵɵtext(20, "Add to List");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate2("", ctx_r1.onetData == null ? null : ctx_r1.onetData.onetSocCode, "-", ctx_r1.onetData == null ? null : ctx_r1.onetData.title, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", (ctx_r1.selectedOnetList == null ? null : ctx_r1.selectedOnetList.length) > 0 ? false : true);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r1.onetList);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", (ctx_r1.selectedOnetList == null ? null : ctx_r1.selectedOnetList.length) > 0 ? false : true);
} }
function OnetJobDutiesComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelementStart(2, "b");
    i0.ɵɵtext(3, "No Data Found!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function OnetJobDutiesComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2, "Add to list of Duties & Sub-duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function OnetJobDutiesComponent_div_29_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.getGlobalErrorMessages("REQUIRED"), " ");
} }
function OnetJobDutiesComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵelementStart(2, "label", 16);
    i0.ɵɵtext(3, "Please select duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 42);
    i0.ɵɵlistener("onChange", function OnetJobDutiesComponent_div_29_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.onChangeDuty($event.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, OnetJobDutiesComponent_div_29_span_5_Template, 2, 1, "span", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r4.dutyList)("showClear", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.addOptionForm.get("duty").touched && (ctx_r4.addOptionForm.get("duty").errors == null ? null : ctx_r4.addOptionForm.get("duty").errors.required));
} }
function OnetJobDutiesComponent_div_30_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.getGlobalErrorMessages("REQUIRED"), " ");
} }
function OnetJobDutiesComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "label", 16);
    i0.ɵɵtext(2, "Please enter duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 45);
    i0.ɵɵtemplate(4, OnetJobDutiesComponent_div_30_span_4_Template, 2, 1, "span", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.addOptionForm.get("others").touched && (ctx_r5.addOptionForm.get("others").errors == null ? null : ctx_r5.addOptionForm.get("others").errors.required));
} }
const _c1$1 = function () { return { width: "60vw" }; };
class OnetJobDutiesComponent {
    constructor(jobDescriptionBuilder, store, onetJobDuties, toast, listJobDutiesService) {
        this.jobDescriptionBuilder = jobDescriptionBuilder;
        this.store = store;
        this.onetJobDuties = onetJobDuties;
        this.toast = toast;
        this.listJobDutiesService = listJobDutiesService;
        this.onetList = [];
        this.dutyList = [];
        this.isForeignCompany = false;
        this.isDutyView = false;
        this.isOthersView = false;
        this.isListView = false;
        this.majorGroupCode = null;
        this.observableSubscription$ = new Subject();
        this.activateView = new EventEmitter();
        this.searchSubject = new Subject();
        this.searchSubject.pipe(debounceTime(500)).subscribe((value) => {
            this.onChangePosition(value);
        });
    }
    ngOnInit() {
        this.onLoadDutySubDuty();
    }
    ngOnChanges(changes) {
        if (changes.jobPositionTitle && changes.jobPositionTitle.currentValue) {
            this.searchPositiontitle = changes.jobPositionTitle.currentValue;
            this.searchSubject.next(this.searchPositiontitle);
        }
        else {
            this.getJobDescription();
        }
    }
    onLoadDutySubDuty() {
        this.dutyList = [];
        this.dutyList = [{ name: 'Others', id: 'other' }];
        this.addOptionForm = this.jobDescriptionBuilder.group({
            addOption: [null, [Validators.required]],
            duty: [null],
            others: [null]
        });
        this.listJobDutiesService.getJobDescription$().subscribe((response) => {
            var _a, _b, _c;
            if (response && response.status === 200) {
                const dutyPayload = {
                    petitionId: (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.petitionId,
                    pbPositionId: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.id
                };
                this.positionId = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.id;
                this.onetJobDuties.getDutyListItems(dutyPayload).pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    if (response && response.status === 200) {
                        this.dutyList = [{ name: 'Others', id: 'other' }, ...response.data];
                        let objectProperty = "name";
                        let objectToMove = "Others";
                        let index = this.dutyList.findIndex(obj => obj[objectProperty] === objectToMove);
                        if (index !== -1) {
                            let object = this.dutyList.splice(index, 1)[0];
                            this.dutyList.push(object);
                        }
                    }
                });
            }
        });
    }
    getJobDescription() {
        this.listJobDutiesService.getJobDescription$().subscribe((response) => {
            if (response.status === 200) {
                this.searchPositiontitle = response === null || response === void 0 ? void 0 : response.data.jobTitle;
                if (this.searchPositiontitle) {
                    this.searchSubject.next(this.searchPositiontitle);
                }
            }
        });
    }
    onSearchInput(event) {
        this.searchPositiontitle = event;
        this.searchSubject.next(event);
    }
    onChangePosition(val) {
        this.majorGroupCode = null;
        this.onetList = [];
        this.isListView = false;
        if (val) {
            this.onetJobDuties.getMajorGroupCodes(this.inputData.visatype, val).pipe(takeUntil(this.observableSubscription$)).subscribe((groupCodeResponse) => {
                this.majourGroupCodeList = groupCodeResponse ? groupCodeResponse : [];
            });
        }
        else {
            this.majourGroupCodeList = [];
        }
    }
    handleMajorGroupCodeChange(event) {
        this.onetList = [];
        if (event.value) {
            this.majorGroupCode = event.value;
            const payload = {
                "searchQuery": this.searchPositiontitle,
                "majorGroup": event.value
            };
            this.onetJobDuties.onetListItems(payload).pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response.status === 200) {
                    this.onetData = response.data;
                    this.onetList = this.onetData.taskList;
                    this.isListView = true;
                }
                else {
                    this.isListView = false;
                }
            });
        }
        else {
            this.majorGroupCode = null;
            this.isListView = false;
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    onSelectionChange() {
        this.selectedOnetList = this.getSelected();
    }
    getSelected() {
        return this.onetSelectionList.selectedOptions.selected.map(s => s.value);
    }
    getUnselected() {
        const differ = [];
        const selected = this.getSelected();
        for (let i = 0; i < this.onetList.length; i++) {
            if (selected.indexOf(this.onetList[i]) === -1) {
                differ.push(this.onetList[i]);
            }
        }
        return differ;
    }
    showListDialog() {
        this.onLoadDutySubDuty();
        this.displayList = true;
        this.isDutyView = false;
        this.isOthersView = false;
    }
    onClickSelectedItem(val) {
        if (val) {
            this.isDutyView = true;
            this.addOptionForm.get("duty").reset();
            this.addOptionForm.get("others").reset();
            this.isOthersView = false;
            this.addOptionForm.get("duty").setValidators([Validators.required]);
            this.addOptionForm.get("duty").updateValueAndValidity();
            this.addOptionForm.get("others").clearValidators();
            this.addOptionForm.get("others").updateValueAndValidity();
        }
        else {
            this.isDutyView = false;
            this.addOptionForm.get("duty").clearValidators();
            this.addOptionForm.get("duty").updateValueAndValidity();
            this.addOptionForm.get("others").clearValidators();
            this.addOptionForm.get("others").updateValueAndValidity();
        }
    }
    addOptionFormSub() {
        let payload = {};
        if (this.addOptionForm.value.addOption == '1') {
            let tempDutyList = [];
            this.selectedOnetList.forEach((item) => {
                tempDutyList.push({
                    "id": null,
                    "name": item,
                    "type": 'ONETLIB',
                    "subJobDuty": []
                });
            });
            payload.duties = tempDutyList;
            payload.id = this.positionId; // positionId
        }
        else {
            let tempDutyList = [];
            this.selectedOnetList.forEach((item) => {
                tempDutyList.push({
                    "id": null,
                    "name": item,
                    "type": 'ONETLIB'
                });
            });
            payload.duties = [
                {
                    "id": null,
                    "name": this.addOptionForm.value.duty == "other" ? this.addOptionForm.value.others : this.dutyList.find(x => x.id == this.addOptionForm.value.duty).name,
                    "subJobDuty": tempDutyList
                }
            ];
            payload.id = this.positionId;
        }
        this.listJobDutiesService.setDuties(payload.duties);
        this.activateView.emit('dutiesCart');
        this.displayList = false;
        this.toast.success('Duty added successfully.', 'Success');
    }
    onChangeDuty(val) {
        if (val == "other") {
            this.isOthersView = true;
            this.addOptionForm.get("others").setValidators([Validators.required]);
            this.addOptionForm.get("others").updateValueAndValidity();
        }
        else {
            this.isOthersView = false;
            this.addOptionForm.get("others").clearValidators();
            this.addOptionForm.get("others").updateValueAndValidity();
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.complete();
    }
}
OnetJobDutiesComponent.ɵfac = function OnetJobDutiesComponent_Factory(t) { return new (t || OnetJobDutiesComponent)(i0.ɵɵdirectiveInject(i2$1.FormBuilder), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(OnetJobDuties), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(ListJobDutiesService)); };
OnetJobDutiesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: OnetJobDutiesComponent, selectors: [["lib-onet-job-duties"]], viewQuery: function OnetJobDutiesComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$4, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.onetSelectionList = _t.first);
    } }, inputs: { inputData: "inputData", jobPositionTitle: "jobPositionTitle" }, outputs: { activateView: "activateView" }, features: [i0.ɵɵNgOnChangesFeature], decls: 34, vars: 15, consts: [["id", "oNetPortion", 1, "row"], [1, "col-12", "p-0"], ["src", "assets/onet.svg", "alt", ""], [1, "col-6", "pb-3", "pl-0"], [1, "label-cls", "row"], ["name", "positionTitle", "type", "text", "pInputText", "", 1, "im-input", "w-100", 3, "ngModel", "ngModelChange", "input"], [1, "col-md-6", "pb-3", "pl-0", "pr-0"], ["appendTo", "body", "name", "selectedMajorGroupCode", "optionValue", "majorGroup", "optionLabel", "majorGroupName", "placeholder", "Select Group Code", 1, "w-100", 3, "options", "filter", "ngModel", "showClear", "ngModelChange", "onChange"], ["pTemplate", "item"], ["class", "col-12 pt-3 pl-0 pr-0 jobDutiesPortion", 4, "ngIf"], ["class", "col-12 noData", 4, "ngIf"], ["id", "displayList", 3, "visible", "visibleChange"], ["pTemplate", "header"], [1, "pt-2", 3, "formGroup", "ngSubmit"], [1, "addDutyPortion"], [1, "col-12", "pl-0", "pr-0"], [1, "required", "mb-0"], ["name", "addOption", "formControlName", "addOption", "value", "1", "label", "Duty", 1, "pr-2", 3, "onClick"], ["name", "addOption", "formControlName", "addOption", "value", "2", "label", "Sub-Duty", 3, "onClick"], ["class", "col-6 pt-2 pl-0 pr-0", 4, "ngIf"], ["class", "col-12 p-0", 4, "ngIf"], [1, "form-row", "pt-3", "footerPortion"], ["mat-stroked-button", "", "color", "primary", 1, "btn", "btn-primary", "addToList", "pull-left", 3, "disabled"], [1, "p-d-flex", "p-ai-center"], [1, "col-12", "pt-3", "pl-0", "pr-0", "jobDutiesPortion"], [1, "row"], [1, "col-6", "p-0"], [1, "m-0"], [1, "col-6", "pt-1", "pr-0"], ["type", "button", 1, "im-btn", "im-btn-outline-primary", "button_whitebg", "pull-right", 3, "disabled", "click"], [1, "row", "contentPortion"], [3, "selectionChange"], ["onetItem", ""], ["checkboxPosition", "before", 3, "value", 4, "ngFor", "ngForOf"], [1, "row", "pb-3"], [1, "col-12", "pt-1", "pl-0"], ["type", "button", 1, "im-btn", "im-btn-outline-primary", "button_whitebg", "pull-left", 3, "disabled", "click"], ["checkboxPosition", "before", 3, "value"], [1, "col-12", "noData"], [1, "align-center"], [1, "col-6", "pt-2", "pl-0", "pr-0"], [1, "form-group", "col-12", "p-0"], ["formControlName", "duty", "optionValue", "id", "placeholder", "Select a duty", "optionLabel", "name", 1, "w-100", 3, "options", "showClear", "onChange"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], ["placeholder", "Enter Duty", "formControlName", "others", "name", "others", "type", "text", "pInputText", "", 1, "im-input", "w-100"]], template: function OnetJobDutiesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "ul");
        i0.ɵɵelementStart(3, "li");
        i0.ɵɵelementStart(4, "h5");
        i0.ɵɵtext(5, "Generate your response through");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "li");
        i0.ɵɵelement(7, "img", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 3);
        i0.ɵɵelementStart(9, "label", 4);
        i0.ɵɵtext(10, " Position Title ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "input", 5);
        i0.ɵɵlistener("ngModelChange", function OnetJobDutiesComponent_Template_input_ngModelChange_11_listener($event) { return ctx.searchPositiontitle = $event; })("input", function OnetJobDutiesComponent_Template_input_input_11_listener($event) { return ctx.onSearchInput($event.target.value); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 6);
        i0.ɵɵelementStart(13, "label", 4);
        i0.ɵɵtext(14, "Major Group Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "p-dropdown", 7);
        i0.ɵɵlistener("ngModelChange", function OnetJobDutiesComponent_Template_p_dropdown_ngModelChange_15_listener($event) { return ctx.majorGroupCode = $event; })("onChange", function OnetJobDutiesComponent_Template_p_dropdown_onChange_15_listener($event) { return ctx.handleMajorGroupCodeChange($event); });
        i0.ɵɵtemplate(16, OnetJobDutiesComponent_ng_template_16_Template, 3, 2, "ng-template", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, OnetJobDutiesComponent_div_17_Template, 21, 5, "div", 9);
        i0.ɵɵtemplate(18, OnetJobDutiesComponent_div_18_Template, 4, 0, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "p-dialog", 11);
        i0.ɵɵlistener("visibleChange", function OnetJobDutiesComponent_Template_p_dialog_visibleChange_19_listener($event) { return ctx.displayList = $event; });
        i0.ɵɵtemplate(20, OnetJobDutiesComponent_ng_template_20_Template, 3, 0, "ng-template", 12);
        i0.ɵɵelementStart(21, "form", 13);
        i0.ɵɵlistener("ngSubmit", function OnetJobDutiesComponent_Template_form_ngSubmit_21_listener() { return ctx.addOptionFormSub(); });
        i0.ɵɵelementStart(22, "div", 14);
        i0.ɵɵelementStart(23, "div", 15);
        i0.ɵɵelementStart(24, "label", 16);
        i0.ɵɵtext(25, "Where do you want to add the selected options?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 15);
        i0.ɵɵelementStart(27, "p-radioButton", 17);
        i0.ɵɵlistener("onClick", function OnetJobDutiesComponent_Template_p_radioButton_onClick_27_listener() { return ctx.onClickSelectedItem(false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "p-radioButton", 18);
        i0.ɵɵlistener("onClick", function OnetJobDutiesComponent_Template_p_radioButton_onClick_28_listener() { return ctx.onClickSelectedItem(true); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(29, OnetJobDutiesComponent_div_29_Template, 6, 3, "div", 19);
        i0.ɵɵtemplate(30, OnetJobDutiesComponent_div_30_Template, 5, 1, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 21);
        i0.ɵɵelementStart(32, "button", 22);
        i0.ɵɵtext(33, "ADD TO LIST");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngModel", ctx.searchPositiontitle);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.majourGroupCodeList)("filter", false)("ngModel", ctx.majorGroupCode)("showClear", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isListView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isListView);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(14, _c1$1));
        i0.ɵɵproperty("visible", ctx.displayList);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.addOptionForm);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.isDutyView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isDutyView && ctx.isOthersView);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.addOptionForm.invalid);
    } }, directives: [i2$1.DefaultValueAccessor, i6$1.InputText, i2$1.NgControlStatus, i2$1.NgModel, i6.Dropdown, i11.PrimeTemplate, i7.NgIf, i10.Dialog, i2$1.ɵangular_packages_forms_forms_ba, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i11$1.RadioButton, i2$1.FormControlName, i12.MatSelectionList, i7.NgForOf, i12.MatListOption], styles: ["#oNetPortion[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;display:flex;justify-content:flex-start;align-items:center;list-style:none;margin:0}#oNetPortion[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0;font-size:16px;font-weight:600;color:#4d4f5c}#oNetPortion[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:160px;height:40px;padding-left:6px}#oNetPortion[_ngcontent-%COMP%]   .addToList[_ngcontent-%COMP%]{background-color:#fff;color:#19a0da;border:1px solid #19a0da;border-radius:3px;padding:3px 12px;font-size:14px}#oNetPortion[_ngcontent-%COMP%]   .jobDutiesPortion[_ngcontent-%COMP%]{border-top:1px dashed #333}#oNetPortion[_ngcontent-%COMP%]   .contentPortion[_ngcontent-%COMP%]{min-height:250px;max-height:250px;overflow:hidden;overflow-y:scroll}#oNetPortion[_ngcontent-%COMP%]   mat-selection-list[_ngcontent-%COMP%]   mat-list-option[_ngcontent-%COMP%]   div.mat-list-text[_ngcontent-%COMP%]{font-size:14px!important}#displayList[_ngcontent-%COMP%]   .footerPortion[_ngcontent-%COMP%], #displayList[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{border-top:1px dashed #ccc}.noData[_ngcontent-%COMP%]{min-height:250px;color:#000;display:flex;justify-content:center;align-items:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OnetJobDutiesComponent, [{
        type: Component,
        args: [{
                selector: 'lib-onet-job-duties',
                templateUrl: './onet-job-duties.component.html',
                styleUrls: ['./onet-job-duties.component.scss']
            }]
    }], function () { return [{ type: i2$1.FormBuilder }, { type: i3.Store }, { type: OnetJobDuties }, { type: i4.ToastrService }, { type: ListJobDutiesService }]; }, { onetSelectionList: [{
            type: ViewChild,
            args: ['onetItem']
        }], inputData: [{
            type: Input
        }], jobPositionTitle: [{
            type: Input
        }], activateView: [{
            type: Output
        }] }); })();

class ChatGptDutiesService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getChatGptDetails(positionTitle) {
        var title = this.toEncrypt(positionTitle);
        return this.httpClient.get(`/getChatGpt/duty/${title}`).pipe(map((response) => {
            return response;
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
ChatGptDutiesService.ɵfac = function ChatGptDutiesService_Factory(t) { return new (t || ChatGptDutiesService)(i0.ɵɵinject(i1.HttpClient)); };
ChatGptDutiesService.ɵprov = i0.ɵɵdefineInjectable({ token: ChatGptDutiesService, factory: ChatGptDutiesService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChatGptDutiesService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function ChatgptDutiesComponent_i_16_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 12);
    i0.ɵɵlistener("click", function ChatgptDutiesComponent_i_16_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onChangeSearch(ctx_r3.searchText); });
    i0.ɵɵelementEnd();
} }
function ChatgptDutiesComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "p", 15);
    i0.ɵɵtext(3, "Results populated from ChatGPT");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 16);
    i0.ɵɵtext(5, " Select the option you prefer. Click \"");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "Add to List");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, "\" and proceed. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 17);
    i0.ɵɵelementStart(10, "button", 18);
    i0.ɵɵlistener("click", function ChatgptDutiesComponent_div_17_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.addToList(); });
    i0.ɵɵtext(11, " Add to List ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ChatgptDutiesComponent_div_20_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 23);
    i0.ɵɵelementStart(1, "th", 24);
    i0.ɵɵelement(2, "p-tableHeaderCheckbox");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 25);
    i0.ɵɵtext(4, "Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 25);
    i0.ɵɵtext(6, "Sub-Duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ChatgptDutiesComponent_div_20_ng_template_3_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(s_r13);
} }
function ChatgptDutiesComponent_div_20_ng_template_3_ul_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 29);
    i0.ɵɵtemplate(1, ChatgptDutiesComponent_div_20_ng_template_3_ul_6_li_1_Template, 2, 1, "li", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", eachDuty_r9 == null ? null : eachDuty_r9.imagilitySubDuties);
} }
function ChatgptDutiesComponent_div_20_ng_template_3_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "No Sub Duties present.");
    i0.ɵɵelementEnd();
} }
function ChatgptDutiesComponent_div_20_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 23);
    i0.ɵɵelementStart(1, "td", 24);
    i0.ɵɵelement(2, "p-tableCheckbox", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 25);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 25);
    i0.ɵɵtemplate(6, ChatgptDutiesComponent_div_20_ng_template_3_ul_6_Template, 2, 1, "ul", 27);
    i0.ɵɵtemplate(7, ChatgptDutiesComponent_div_20_ng_template_3_p_7_Template, 2, 0, "p", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r9 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", eachDuty_r9);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(eachDuty_r9 == null ? null : eachDuty_r9.imagilityDuty);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (eachDuty_r9 == null ? null : eachDuty_r9.imagilitySubDuties) && (eachDuty_r9 == null ? null : eachDuty_r9.imagilitySubDuties == null ? null : eachDuty_r9.imagilitySubDuties.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (eachDuty_r9 == null ? null : eachDuty_r9.imagilitySubDuties) && (eachDuty_r9 == null ? null : eachDuty_r9.imagilitySubDuties == null ? null : eachDuty_r9.imagilitySubDuties.length) == 0);
} }
const _c0$3 = function () { return { "min-width": "100%" }; };
function ChatgptDutiesComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "p-table", 20);
    i0.ɵɵlistener("selectionChange", function ChatgptDutiesComponent_div_20_Template_p_table_selectionChange_1_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.selectedDuties = $event; });
    i0.ɵɵtemplate(2, ChatgptDutiesComponent_div_20_ng_template_2_Template, 7, 0, "ng-template", 21);
    i0.ɵɵtemplate(3, ChatgptDutiesComponent_div_20_ng_template_3_Template, 8, 4, "ng-template", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r2.dutiesArr)("selection", ctx_r2.selectedDuties)("tableStyle", i0.ɵɵpureFunction0(3, _c0$3));
} }
class ChatgptDutiesComponent {
    constructor(apiService, dialogService, store, toastr, listOfDutiesService) {
        this.apiService = apiService;
        this.dialogService = dialogService;
        this.store = store;
        this.toastr = toastr;
        this.listOfDutiesService = listOfDutiesService;
        this.activateView = new EventEmitter();
        // searchSubject: Subject<string> = new Subject<string>();
        this.observableSubscription$ = new Subject();
        this.categoryList = [];
        this.jobRoleOptions = [];
        this.dutiesArr = [];
        this.disabledControls = false;
        // this.searchSubject.pipe(
        //   debounceTime(500)
        // ).subscribe((value) => {
        //   this.onChangeSearch(value, 1);
        // });
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.jobPositionTitle && changes.jobPositionTitle.currentValue) {
            this.searchText = changes.jobPositionTitle.currentValue;
            this.onChangeSearch(this.searchText);
        }
        else {
            this.getJobDescription();
        }
    }
    getJobDescription() {
        this.listOfDutiesService.getJobDescription$().subscribe((response) => {
            if (response.status === 200) {
                this.searchText = response === null || response === void 0 ? void 0 : response.data.jobTitle;
                if (this.searchText) {
                    this.onChangeSearch(this.searchText);
                }
            }
        });
    }
    // onSearchInput(event: any) {
    //   this.searchSubject.next(event);
    //   // this.onChangeSearch(event); 
    // }
    onChangeSearch(val) {
        this.dutiesArr = [];
        this.selectedDuties = [];
        if (val) {
            this.apiService.getChatGptDetails(val).pipe(takeUntil(this.observableSubscription$)).subscribe((resData) => {
                if (resData && resData.status === 200) {
                    if (resData && resData.data.chatGptResponseDTOList && resData.data.chatGptResponseDTOList.length > 0) {
                        this.dutiesArr = [...resData.data.chatGptResponseDTOList];
                        this.dutiesArr.forEach(e => {
                            e.type = 'CHATGPTLIB';
                        });
                    }
                }
                else {
                    CustomErrorToastComponent.showErrorToast(this.toastr, resData.message);
                }
            });
        }
    }
    addToList() {
        let _duties = this.selectedDuties.map(e1 => {
            let _e1 = {};
            _e1.subJobDuty = e1.imagilitySubDuties.map(e2 => {
                let _e2 = {};
                _e2.id = null;
                _e2.name = e2;
                return _e2;
            });
            _e1.id = null;
            _e1.name = e1.imagilityDuty;
            return _e1;
        });
        this.listOfDutiesService.setDuties(_duties);
        this.activateView.emit('dutiesCart');
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
ChatgptDutiesComponent.ɵfac = function ChatgptDutiesComponent_Factory(t) { return new (t || ChatgptDutiesComponent)(i0.ɵɵdirectiveInject(ChatGptDutiesService), i0.ɵɵdirectiveInject(i2.DialogService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(ListJobDutiesService)); };
ChatgptDutiesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ChatgptDutiesComponent, selectors: [["lib-chatgpt-duties"]], inputs: { inputData: "inputData", jobPositionTitle: "jobPositionTitle" }, outputs: { activateView: "activateView" }, features: [i0.ɵɵNgOnChangesFeature], decls: 21, vars: 4, consts: [["id", "chatGpt", 1, "library-wrapper"], [1, "row"], [1, "col-12", "p-0"], [1, "chatGptHeader"], ["src", "assets/chatGpt.png", "alt", ""], [1, "col-12", "p-3", "searchPortion"], ["appearance", "fill", 1, "w-50"], ["matInput", "", "placeholder", "Message ChatGPT", 3, "ngModel", "ngModelChange"], ["class", "fa fa-search", "matSuffix", "", "aria-hidden", "true", 3, "click", 4, "ngIf"], ["class", "row results-wrapper", 4, "ngIf"], ["id", "imgLibrary", 1, "col-md-12", "p-0"], ["class", "library-table-wrapper", 4, "ngIf"], ["matSuffix", "", "aria-hidden", "true", 1, "fa", "fa-search", 3, "click"], [1, "row", "results-wrapper"], [1, "col-md-8", "pl-0"], [1, "bold-title"], [1, "text-warning", "warn-caption"], [1, "col-md-4", "results-action-wrapper", "pr-0"], ["type", "button", 1, "im-btn", "im-btn-outline-primary", "button_whitebg", 3, "click"], [1, "library-table-wrapper"], ["dataKey", "id", 3, "value", "selection", "tableStyle", "selectionChange"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "dutyHeadPortion"], [1, "selectPortion"], [1, "dutyPortion"], [3, "value"], ["class", "sub-duties", 4, "ngIf"], [4, "ngIf"], [1, "sub-duties"], [4, "ngFor", "ngForOf"]], template: function ChatgptDutiesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "ul", 3);
        i0.ɵɵelementStart(4, "li");
        i0.ɵɵelementStart(5, "h5");
        i0.ɵɵtext(6, "Generate your response through");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "li");
        i0.ɵɵelement(8, "img", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "li");
        i0.ɵɵelementStart(10, "h5");
        i0.ɵɵtext(11, "ChatGPT");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 1);
        i0.ɵɵelementStart(13, "div", 5);
        i0.ɵɵelementStart(14, "mat-form-field", 6);
        i0.ɵɵelementStart(15, "input", 7);
        i0.ɵɵlistener("ngModelChange", function ChatgptDutiesComponent_Template_input_ngModelChange_15_listener($event) { return ctx.searchText = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, ChatgptDutiesComponent_i_16_Template, 1, 0, "i", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, ChatgptDutiesComponent_div_17_Template, 12, 0, "div", 9);
        i0.ɵɵelementStart(18, "div", 1);
        i0.ɵɵelementStart(19, "div", 10);
        i0.ɵɵtemplate(20, ChatgptDutiesComponent_div_20_Template, 4, 4, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("ngModel", ctx.searchText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.searchText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.dutiesArr == null ? null : ctx.dutiesArr.length) > 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.dutiesArr == null ? null : ctx.dutiesArr.length) > 0);
    } }, directives: [i6$2.MatFormField, i7$1.MatInput, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i7.NgIf, i6$2.MatSuffix, i8.Table, i11.PrimeTemplate, i8.TableHeaderCheckbox, i8.TableCheckbox, i7.NgForOf], styles: [".displayFlex[_ngcontent-%COMP%]{display:flex}.warn-caption[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700}.align-bottom[_ngcontent-%COMP%]{align-items:end}.bold-title[_ngcontent-%COMP%]{font-weight:700;font-size:16px}.results-wrapper[_ngcontent-%COMP%]{border-top:1px dashed #333;padding-top:15px;margin-top:15px;.results-action-wrapper{display:flex;justify-content:end;align-items:center}}.warn-caption[_ngcontent-%COMP%]{font-size:14px}#chatGpt[_ngcontent-%COMP%]{div.searchPortion{text-align:center;i.fa.fa-search:hover{color:#1ca0da;cursor:pointer}}ul.chatGptHeader{padding:0;display:flex;justify-content:flex-start;align-items:center;list-style:none;margin:0;li{h5{margin:0;font-size:16px;font-weight:600;color:#4d4f5c}img{width:25px;height:26px;background-color:#1ca0da;border-radius:4px;padding:2px;margin-left:10px;margin-right:4px}}}.dutyHeadPortion{.dutyPortion{ul{padding-left:15px!important;margin-bottom:0!important}}}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChatgptDutiesComponent, [{
        type: Component,
        args: [{
                selector: 'lib-chatgpt-duties',
                templateUrl: './chatgpt-duties.component.html',
                styleUrls: ['./chatgpt-duties.component.css']
            }]
    }], function () { return [{ type: ChatGptDutiesService }, { type: i2.DialogService }, { type: i3.Store }, { type: i4.ToastrService }, { type: ListJobDutiesService }]; }, { inputData: [{
            type: Input
        }], activateView: [{
            type: Output
        }], jobPositionTitle: [{
            type: Input
        }] }); })();

function CreateDutiesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "p", 12);
    i0.ɵɵtext(3, "Add Duty and Sub-duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 13);
    i0.ɵɵtext(5, "Add ");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "one duty");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, " and ");
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10, "multiple sub-duties");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, " at a time. Click \"");
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13, "Add to List");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14, "\" and proceed to add next.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CreateDutiesComponent_div_15_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function CreateDutiesComponent_div_15_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.addSubDuty(); });
    i0.ɵɵtext(1, "+");
    i0.ɵɵelementEnd();
} }
function CreateDutiesComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "textarea", 15);
    i0.ɵɵtemplate(2, CreateDutiesComponent_div_15_button_2_Template, 2, 0, "button", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r2 = ctx.$implicit;
    const last_r3 = ctx.last;
    i0.ɵɵproperty("formGroup", s_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", last_r3);
} }
class CreateDutiesComponent {
    constructor(listJobDutiesService, fb, toastr) {
        this.listJobDutiesService = listJobDutiesService;
        this.fb = fb;
        this.toastr = toastr;
        this.activateView = new EventEmitter();
        this.showHeading = true;
        this.dutyForm = fb.group({
            'id': new FormControl(null),
            'name': new FormControl(null, [Validators.required]),
            'subJobDuty': new FormArray([])
        });
    }
    ngOnInit() {
        /**
         * Add one sub duty
         */
        this.addSubDuty();
    }
    addSubDuty() {
        this.dutyForm.get('subJobDuty').push(this.fb.group({
            'id': new FormControl(null),
            'name': new FormControl(null)
        }));
    }
    addToList() {
        let _subJobDuty = this.dutyForm.value.subJobDuty.filter(e => !!e.name);
        let _dutyObj = Object.assign({}, this.dutyForm.value);
        _dutyObj.subJobDuty = _subJobDuty;
        this.listJobDutiesService.setDuties([_dutyObj]);
        this.dutyForm.reset();
        this.toastr.success('Duty added successfully.', 'Success');
    }
    get subJobDutyForm() {
        return this.dutyForm.get('subJobDuty');
    }
}
CreateDutiesComponent.ɵfac = function CreateDutiesComponent_Factory(t) { return new (t || CreateDutiesComponent)(i0.ɵɵdirectiveInject(ListJobDutiesService), i0.ɵɵdirectiveInject(i2$1.FormBuilder), i0.ɵɵdirectiveInject(i4.ToastrService)); };
CreateDutiesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CreateDutiesComponent, selectors: [["lib-create-duties"]], inputs: { inputData: "inputData", showHeading: "showHeading" }, outputs: { activateView: "activateView" }, decls: 18, vars: 4, consts: [[1, "create-duties-wrapper"], ["class", "row", 4, "ngIf"], [3, "formGroup"], [1, "row"], [1, "col-md-8", "pl-0", "pr-0"], ["for", "duty"], ["formControlName", "name", "id", "duty", "cols", "30", "rows", "10", 1, "duty-ta"], [1, "bold"], ["formArrayName", "subJobDuty"], ["class", "sub-duties-wrapper", 3, "formGroup", 4, "ngFor", "ngForOf"], ["type", "button", 1, "add-to-list", 3, "disabled", "click"], [1, "col-md-12", "pl-0", "pr-0"], [1, "create-duties-title"], [1, "text-warning", "warn-caption"], [1, "sub-duties-wrapper", 3, "formGroup"], ["formControlName", "name", "cols", "30", "rows", "10", 1, "duty-ta"], ["type", "button", "class", "add-subduty", 3, "click", 4, "ngIf"], ["type", "button", 1, "add-subduty", 3, "click"]], template: function CreateDutiesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CreateDutiesComponent_div_1_Template, 15, 0, "div", 1);
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "label", 5);
        i0.ɵɵtext(6, "Add Beneficiary Duty");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "textarea", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 3);
        i0.ɵɵelementStart(9, "div", 4);
        i0.ɵɵelementStart(10, "p", 7);
        i0.ɵɵtext(11, "Add Sub-duties");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "label", 5);
        i0.ɵɵtext(13, " You can add multiple sub duties by clicking plus icon ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerStart(14, 8);
        i0.ɵɵtemplate(15, CreateDutiesComponent_div_15_Template, 3, 2, "div", 9);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "button", 10);
        i0.ɵɵlistener("click", function CreateDutiesComponent_Template_button_click_16_listener() { return ctx.addToList(); });
        i0.ɵɵtext(17, "Add to List");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showHeading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.dutyForm);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("ngForOf", ctx.subJobDutyForm.controls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.dutyForm.invalid);
    } }, directives: [i7.NgIf, i2$1.ɵangular_packages_forms_forms_ba, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.FormControlName, i2$1.FormArrayName, i7.NgForOf], styles: [".warn-caption[_ngcontent-%COMP%]{font-size:16px}.warn-caption[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700}[for=duty][_ngcontent-%COMP%]{font-size:16px}#duty[_ngcontent-%COMP%]{width:100%;height:100px}.bold[_ngcontent-%COMP%]{font-weight:700;font-size:16px}.duty-ta[_ngcontent-%COMP%]{width:80%;height:100px;margin-bottom:15px}.sub-duties-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center}.add-subduty[_ngcontent-%COMP%]{background-color:#4cba1f;border:none;padding:2px 22px;font-size:40px;border-radius:50%;color:#fff;margin-left:15px;box-shadow:2px 2px 10px 0 #a8a8a8}.add-subduty.active[_ngcontent-%COMP%]{box-shadow:none}.add-to-list[_ngcontent-%COMP%]{padding:8px 20px;border-radius:6px;border:1px solid #1ca0da;color:#1ca0da;background-color:#fff;float:right}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateDutiesComponent, [{
        type: Component,
        args: [{
                selector: 'lib-create-duties',
                templateUrl: './create-duties.component.html',
                styleUrls: ['./create-duties.component.scss']
            }]
    }], function () { return [{ type: ListJobDutiesService }, { type: i2$1.FormBuilder }, { type: i4.ToastrService }]; }, { inputData: [{
            type: Input
        }], activateView: [{
            type: Output
        }], showHeading: [{
            type: Input
        }] }); })();

function DutiesCartComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function DutiesCartComponent_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.save(); });
    i0.ɵɵtext(1, "Save");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.positionId == 0);
} }
function DutiesCartComponent_p_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "No Duties Added to the list");
    i0.ɵɵelementEnd();
} }
function DutiesCartComponent_p_table_14_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Sub-Duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 16);
    i0.ɵɵtext(6, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DutiesCartComponent_p_table_14_ng_template_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(eachDuty_r7.name);
} }
function DutiesCartComponent_p_table_14_ng_template_2_textarea_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 23);
    i0.ɵɵlistener("change", function DutiesCartComponent_p_table_14_ng_template_2_textarea_3_Template_textarea_change_0_listener($event) { i0.ɵɵrestoreView(_r18); const index_r8 = i0.ɵɵnextContext().rowIndex; const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.onDutyValueChange($event, index_r8); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("value", eachDuty_r7.editedValue);
} }
function DutiesCartComponent_p_table_14_ng_template_2_ul_5_li_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r21 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(s_r21.name);
} }
function DutiesCartComponent_p_table_14_ng_template_2_ul_5_li_1_textarea_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 23);
    i0.ɵɵlistener("change", function DutiesCartComponent_p_table_14_ng_template_2_ul_5_li_1_textarea_2_Template_textarea_change_0_listener($event) { i0.ɵɵrestoreView(_r28); const i_r22 = i0.ɵɵnextContext().index; const index_r8 = i0.ɵɵnextContext(2).rowIndex; const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.onSubDutyValueChange($event, index_r8, i_r22); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r22 = i0.ɵɵnextContext().index;
    const eachDuty_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("value", eachDuty_r7.editedSubJobDuty[i_r22].editedValue);
} }
function DutiesCartComponent_p_table_14_ng_template_2_ul_5_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, DutiesCartComponent_p_table_14_ng_template_2_ul_5_li_1_span_1_Template, 2, 1, "span", 10);
    i0.ɵɵtemplate(2, DutiesCartComponent_p_table_14_ng_template_2_ul_5_li_1_textarea_2_Template, 1, 1, "textarea", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachDuty_r7.isEdited == false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachDuty_r7.isEdited);
} }
function DutiesCartComponent_p_table_14_ng_template_2_ul_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 24);
    i0.ɵɵtemplate(1, DutiesCartComponent_p_table_14_ng_template_2_ul_5_li_1_Template, 3, 2, "li", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", eachDuty_r7.subJobDuty);
} }
function DutiesCartComponent_p_table_14_ng_template_2_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "No Sub Duties present.");
    i0.ɵɵelementEnd();
} }
function DutiesCartComponent_p_table_14_ng_template_2_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function DutiesCartComponent_p_table_14_ng_template_2_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r36); const index_r8 = i0.ɵɵnextContext().rowIndex; const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.editDuty(index_r8); });
    i0.ɵɵelement(1, "img", 27);
    i0.ɵɵelementEnd();
} }
function DutiesCartComponent_p_table_14_ng_template_2_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function DutiesCartComponent_p_table_14_ng_template_2_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r39); const index_r8 = i0.ɵɵnextContext().rowIndex; const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.saveDuty(index_r8); });
    i0.ɵɵelement(1, "img", 29);
    i0.ɵɵelementEnd();
} }
function DutiesCartComponent_p_table_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtemplate(2, DutiesCartComponent_p_table_14_ng_template_2_span_2_Template, 2, 1, "span", 10);
    i0.ɵɵtemplate(3, DutiesCartComponent_p_table_14_ng_template_2_textarea_3_Template, 1, 1, "textarea", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, DutiesCartComponent_p_table_14_ng_template_2_ul_5_Template, 2, 1, "ul", 18);
    i0.ɵɵtemplate(6, DutiesCartComponent_p_table_14_ng_template_2_p_6_Template, 2, 0, "p", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 16);
    i0.ɵɵtemplate(8, DutiesCartComponent_p_table_14_ng_template_2_button_8_Template, 2, 0, "button", 19);
    i0.ɵɵtemplate(9, DutiesCartComponent_p_table_14_ng_template_2_button_9_Template, 2, 0, "button", 20);
    i0.ɵɵelementStart(10, "button", 21);
    i0.ɵɵlistener("click", function DutiesCartComponent_p_table_14_ng_template_2_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r41); const index_r8 = ctx.rowIndex; const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.delete(index_r8); });
    i0.ɵɵelement(11, "img", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", eachDuty_r7.isEdited == false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachDuty_r7.isEdited);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", eachDuty_r7.subJobDuty && eachDuty_r7.subJobDuty.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachDuty_r7.subJobDuty && eachDuty_r7.subJobDuty.length == 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", eachDuty_r7.isEdited == false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachDuty_r7.isEdited == true);
} }
const _c0$2 = function () { return { "min-width": "100%" }; };
function DutiesCartComponent_p_table_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-table", 13);
    i0.ɵɵtemplate(1, DutiesCartComponent_p_table_14_ng_template_1_Template, 7, 0, "ng-template", 14);
    i0.ɵɵtemplate(2, DutiesCartComponent_p_table_14_ng_template_2_Template, 12, 6, "ng-template", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r2.selectedDuties)("tableStyle", i0.ɵɵpureFunction0(2, _c0$2));
} }
class DutiesCartComponent {
    constructor(listJobDutiesService, toastr) {
        this.listJobDutiesService = listJobDutiesService;
        this.toastr = toastr;
        this.activateView = new EventEmitter();
        this.onDuties = new EventEmitter();
        this.dutiesCount = 0;
        this.selectedDuties = null;
        this.observableSubscription$ = new Subject();
        this.positionId = 0;
    }
    ngOnInit() {
        /**
         * Duties has the selected Cart(Add to List) values
         */
        this.listJobDutiesService.getDuties().pipe(takeUntil(this.observableSubscription$)).subscribe(val => {
            if (val) {
                this.selectedDuties = val.map(e1 => {
                    let _e1 = Object.assign({}, e1);
                    _e1.subJobDuty = e1.subJobDuty.map(e2 => {
                        let _e2 = Object.assign({}, e2);
                        _e2.isEdited = false;
                        return _e2;
                    });
                    _e1.isEdited = false;
                    return _e1;
                });
                this.dutiesCount = val.length;
            }
        });
        this.listJobDutiesService.getJobDescription$().subscribe((response) => {
            if (response && response.data) {
                this.positionId = response.data.id;
            }
            else {
                this.positionId = 0;
            }
        });
    }
    /**
     * On click, on edit icon in the table
     */
    editDuty(index) {
        this.selectedDuties = this.selectedDuties.map(e1 => {
            let _e1 = Object.assign({}, e1);
            _e1.editedValue = e1.name;
            _e1.isEdited = false;
            _e1.editedSubJobDuty = e1.subJobDuty.map(e2 => {
                let _e2 = Object.assign({}, e2);
                _e2.editedValue = e2.name;
                return _e2;
            });
            return _e1;
        });
        this.selectedDuties[index].isEdited = true;
    }
    /**
     * On click, on save icon in the table
     */
    saveDuty(index) {
        this.selectedDuties[index].name = this.selectedDuties[index].editedValue;
        this.selectedDuties[index].subJobDuty = this.selectedDuties[index].editedSubJobDuty.map(e1 => {
            let _e1 = Object.assign({}, e1);
            _e1.name = e1.editedValue;
            _e1.isEdited = false;
            return _e1;
        });
        this.selectedDuties[index].isEdited = false;
    }
    delete(index) {
        this.selectedDuties.splice(index, 1);
        this.listJobDutiesService.setDuties(this.selectedDuties, false);
    }
    /**
     * Create a copy of the Array of objects for keeping input and displaying on table.
     */
    // getOrganisedDuties(selectedDuties: any[]): any[] {
    //   return selectedDuties.map(e1 => {
    //     let _e1: any = {};
    //     _e1.name = e1.duty || e1.name;
    //     _e1.isEdited = false;
    //     _e1.subduty = e1.subJobDuty || e1.subduty;
    //     _e1.id = e1.dutyId || e1.id;
    //     _e1.editedSubJobDuty = _e1.subduty.map(e2 => {
    //       let _e2: any = {};
    //       _e2.id = e2.dutyId || e2.id;
    //       e2.id = e2.dutyId || e2.id;
    //       e2.name = e2.duty || e2.name;
    //       _e2.name = e2.duty || e2.name;
    //       _e2.editedValue = _e2.name;
    //       return _e2;
    //     });
    //     return _e1;
    //   });
    // }
    save() {
        // let _duties = this.selectedDuties.map(e1 => {
        //   let _e1 = {};
        //   _e1['id'] = e1.id;
        //   _e1['name'] = e1.name;
        //   _e1['type'] = e1.type;
        //   _e1['subJobDuty'] = e1.subJobDuty.map(e2 => {
        //     let _e2 = {};
        //     _e2['id'] = e2.id;
        //     _e2['name'] = e2.name;
        //     return _e2;
        //   });
        //   return _e1;
        // });
        let _payload = {
            duties: this.selectedDuties,
            id: this.positionId
        };
        this.onDuties.emit(_payload);
        this.selectedDuties.forEach((e1) => {
            delete e1.isEdited;
            delete e1.editedValue;
            e1.subJobDuty.forEach(e2 => {
                delete e2.isEdited;
                delete e2.editedValue;
            });
        });
        this.listJobDutiesService.saveOnetDutySubDuty(this.inputData, _payload).subscribe(response => {
            if (response && response.status == 200) {
                this.toastr.success('Duties saved succesfully.', 'Success');
                // API CALL FOR SAVING then after successful save set locally in Behavior S11ubject
                this.listJobDutiesService.setDuties(this.selectedDuties, false);
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Something went wrong!');
            }
        });
    }
    deleteAll() {
        this.listJobDutiesService.setDuties([], false);
    }
    onDutyValueChange(event, dutyIndex) {
        this.selectedDuties[dutyIndex].editedValue = event.target.value;
    }
    onSubDutyValueChange(event, dutyIndex, subDutyIndex) {
        this.selectedDuties[dutyIndex].editedSubJobDuty[subDutyIndex].editedValue = event.target.value;
    }
    ngOnDestroy() {
        this.observableSubscription$.complete();
    }
}
DutiesCartComponent.ɵfac = function DutiesCartComponent_Factory(t) { return new (t || DutiesCartComponent)(i0.ɵɵdirectiveInject(ListJobDutiesService), i0.ɵɵdirectiveInject(i4.ToastrService)); };
DutiesCartComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DutiesCartComponent, selectors: [["lib-duties-cart"]], inputs: { inputData: "inputData", isSave: "isSave", isWizard: "isWizard" }, outputs: { activateView: "activateView", onDuties: "onDuties" }, decls: 15, vars: 6, consts: [[1, "duties-cart-wrapper"], [1, "row"], [1, "col-md-6", "pl-0", "pr-0"], [1, "duties-txt"], [1, "main-btns-wrapper"], ["type", "button", 1, "without-border-btn", "delete-all-btn", 3, "disabled", "click"], ["src", "/assets/delete_invite.png", "alt", "Delete All"], ["type", "button", "class", "blue-btn", 3, "disabled", "click", 4, "ngIf"], ["id", "cartDutyPortion", 1, "row"], [1, "col-md-12", "pl-0", "pr-0"], [4, "ngIf"], ["dataKey", "id", 3, "value", "tableStyle", 4, "ngIf"], ["type", "button", 1, "blue-btn", 3, "disabled", "click"], ["dataKey", "id", 3, "value", "tableStyle"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "text-center"], ["id", "", "cols", "30", "rows", "10", 3, "value", "change", 4, "ngIf"], ["class", "sub-duties", 4, "ngIf"], ["type", "button", "class", "action-btn", "pTooltip", "Edit", 3, "click", 4, "ngIf"], ["type", "button", "class", "action-btn", "pTooltip", "Save", 3, "click", 4, "ngIf"], ["type", "button", "pTooltip", "Delete", 1, "action-btn", "left-sep", 3, "click"], ["src", "/assets/images/delete.png", "alt", "Delete"], ["id", "", "cols", "30", "rows", "10", 3, "value", "change"], [1, "sub-duties"], [4, "ngFor", "ngForOf"], ["type", "button", "pTooltip", "Edit", 1, "action-btn", 3, "click"], ["src", "/assets/images/edit.png", "alt", "Edit"], ["type", "button", "pTooltip", "Save", 1, "action-btn", 3, "click"], ["src", "/assets/images/save.png", "alt", "Save"]], template: function DutiesCartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "button", 5);
        i0.ɵɵlistener("click", function DutiesCartComponent_Template_button_click_7_listener() { return ctx.deleteAll(); });
        i0.ɵɵelement(8, "img", 6);
        i0.ɵɵtext(9, " Delete All ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, DutiesCartComponent_button_10_Template, 2, 1, "button", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵtemplate(13, DutiesCartComponent_p_13_Template, 2, 0, "p", 10);
        i0.ɵɵtemplate(14, DutiesCartComponent_p_table_14_Template, 3, 3, "p-table", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate2("", ctx.dutiesCount, " ", ctx.dutiesCount != 1 ? "Duties" : "Duty", " and sub-duties added");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.dutiesCount === 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isSave && !ctx.isWizard);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.selectedDuties == null || ctx.selectedDuties.length == 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedDuties && ctx.selectedDuties.length > 0);
    } }, directives: [i7.NgIf, i8.Table, i11.PrimeTemplate, i6$3.Tooltip, i7.NgForOf], styles: [".without-border-btn[_ngcontent-%COMP%]{color:#1ca0da;background:transparent;border:none}.justify-bottom[_ngcontent-%COMP%], .main-btns-wrapper[_ngcontent-%COMP%]{justify-content:end}.main-btns-wrapper[_ngcontent-%COMP%]{display:flex;margin-bottom:15px;margin-top:15px}.action-btn[_ngcontent-%COMP%]{background:transparent;border:none}.action-btn[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:16px;height:20px}.blue-btn[_ngcontent-%COMP%]{background-color:#1ca0da;border:none;color:#fff;padding:8px 22px;border-radius:6px}.delete-all-btn[_ngcontent-%COMP%]{margin-right:15px}.duties-txt[_ngcontent-%COMP%]{font-weight:700}.sub-duties[_ngcontent-%COMP%]{padding-left:15px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DutiesCartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-duties-cart',
                templateUrl: './duties-cart.component.html',
                styleUrls: ['./duties-cart.component.scss']
            }]
    }], function () { return [{ type: ListJobDutiesService }, { type: i4.ToastrService }]; }, { inputData: [{
            type: Input
        }], isSave: [{
            type: Input
        }], activateView: [{
            type: Output
        }], onDuties: [{
            type: Output
        }], isWizard: [{
            type: Input
        }] }); })();

function JobDutiesResultsComponent_div_17_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", item_r11.majorGroup, "-", item_r11.majorGroupName, " ");
} }
function JobDutiesResultsComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "label", 23);
    i0.ɵɵtext(3, " Position Title ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 24);
    i0.ɵɵlistener("ngModelChange", function JobDutiesResultsComponent_div_17_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.searchPositiontitle = $event; })("input", function JobDutiesResultsComponent_div_17_Template_input_input_4_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.onSearchInput($event.target.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵelementStart(6, "label", 23);
    i0.ɵɵtext(7, "Major Group Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p-dropdown", 25);
    i0.ɵɵlistener("ngModelChange", function JobDutiesResultsComponent_div_17_Template_p_dropdown_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.majorGroupCode = $event; })("onChange", function JobDutiesResultsComponent_div_17_Template_p_dropdown_onChange_8_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.handleMajorGroupCodeChange($event); });
    i0.ɵɵtemplate(9, JobDutiesResultsComponent_div_17_ng_template_9_Template, 3, 2, "ng-template", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r0.searchPositiontitle);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r0.majourGroupCodeList)("filter", false)("ngModel", ctx_r0.majorGroupCode)("showClear", true);
} }
function JobDutiesResultsComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "button", 28);
    i0.ɵɵlistener("click", function JobDutiesResultsComponent_div_18_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.isListView = false; });
    i0.ɵɵelement(2, "i", 29);
    i0.ɵɵtext(3, " Back ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0$1 = function (a0) { return { "last": a0 }; };
function JobDutiesResultsComponent_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelementStart(2, "p-checkbox", 33);
    i0.ɵɵlistener("onChange", function JobDutiesResultsComponent_div_19_div_1_Template_p_checkbox_onChange_2_listener($event) { i0.ɵɵrestoreView(_r24); const eachDuty_r20 = ctx.$implicit; const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.selectUnselectDuty($event, eachDuty_r20, "ONETLIB"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 34);
    i0.ɵɵelementStart(4, "p", 35);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    const last_r22 = ctx.last;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$1, last_r22));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("name", "onetLibDuty", i_r21, "");
    i0.ɵɵpropertyInterpolate1("inputId", "onetLibDuty-", i_r21, "");
    i0.ɵɵproperty("value", eachDuty_r20);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(eachDuty_r20);
} }
function JobDutiesResultsComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, JobDutiesResultsComponent_div_19_div_1_Template, 6, 7, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.onetDutyList);
} }
function JobDutiesResultsComponent_div_21_i_4_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 40);
    i0.ɵɵlistener("click", function JobDutiesResultsComponent_div_21_i_4_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.onChangeSearch(ctx_r26.searchText); });
    i0.ɵɵelementEnd();
} }
function JobDutiesResultsComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵelementStart(2, "mat-form-field", 37);
    i0.ɵɵelementStart(3, "input", 38);
    i0.ɵɵlistener("ngModelChange", function JobDutiesResultsComponent_div_21_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.searchText = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JobDutiesResultsComponent_div_21_i_4_Template, 1, 0, "i", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r3.searchText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.searchText);
} }
function JobDutiesResultsComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "button", 28);
    i0.ɵɵlistener("click", function JobDutiesResultsComponent_div_22_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.isListViewChatGPT = false; });
    i0.ɵɵelement(2, "i", 29);
    i0.ɵɵtext(3, " Back ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDutiesResultsComponent_div_23_div_1_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r38 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(s_r38);
} }
function JobDutiesResultsComponent_div_23_div_1_ul_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 43);
    i0.ɵɵtemplate(1, JobDutiesResultsComponent_div_23_div_1_ul_6_li_1_Template, 2, 1, "li", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r33 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", eachDuty_r33.imagilitySubDuties);
} }
function JobDutiesResultsComponent_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelementStart(2, "p-checkbox", 33);
    i0.ɵɵlistener("onChange", function JobDutiesResultsComponent_div_23_div_1_Template_p_checkbox_onChange_2_listener($event) { i0.ɵɵrestoreView(_r41); const eachDuty_r33 = ctx.$implicit; const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.selectUnselectDuty($event, eachDuty_r33, "CHATGPTLIB"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 34);
    i0.ɵɵelementStart(4, "p", 41);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, JobDutiesResultsComponent_div_23_div_1_ul_6_Template, 2, 1, "ul", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r33 = ctx.$implicit;
    const i_r34 = ctx.index;
    const last_r35 = ctx.last;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1, last_r35));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("name", "chatGptLibDuty", i_r34, "");
    i0.ɵɵpropertyInterpolate1("inputId", "chatGptLibDuty-", i_r34, "");
    i0.ɵɵproperty("value", eachDuty_r33);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(eachDuty_r33.imagilityDuty);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (eachDuty_r33 == null ? null : eachDuty_r33.imagilitySubDuties == null ? null : eachDuty_r33.imagilitySubDuties.length) > 0);
} }
function JobDutiesResultsComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, JobDutiesResultsComponent_div_23_div_1_Template, 7, 8, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.dutiesArrChatGPT);
} }
function JobDutiesResultsComponent_p_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 45);
    i0.ɵɵtext(1, "Select category and position to generate prompt ");
    i0.ɵɵelementEnd();
} }
const _c1 = function () { return { width: "100%" }; };
function JobDutiesResultsComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "label", 47);
    i0.ɵɵtext(3, " Job Category");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 48);
    i0.ɵɵlistener("onChange", function JobDutiesResultsComponent_div_27_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.onChangeCategory($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 49);
    i0.ɵɵelementStart(6, "label", 47);
    i0.ɵɵtext(7, "Job Position");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p-dropdown", 50);
    i0.ɵɵlistener("onChange", function JobDutiesResultsComponent_div_27_Template_p_dropdown_onChange_8_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.setPositionTitle($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 51);
    i0.ɵɵelementStart(10, "button", 52);
    i0.ɵɵlistener("click", function JobDutiesResultsComponent_div_27_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r43); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.saveJobRoleOrPopulateDuties(); });
    i0.ɵɵtext(11, " Generate ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(7, _c1));
    i0.ɵɵproperty("options", ctx_r7.categoryList)("disabled", ctx_r7.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r7.jobRoleOptions)("filter", false)("disabled", ctx_r7.disabledControls);
} }
function JobDutiesResultsComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "button", 28);
    i0.ɵɵlistener("click", function JobDutiesResultsComponent_div_28_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.isFormView = true; });
    i0.ɵɵelement(2, "i", 29);
    i0.ɵɵtext(3, " Back ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDutiesResultsComponent_div_29_div_1_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r54 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(s_r54.duty);
} }
function JobDutiesResultsComponent_div_29_div_1_ul_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 43);
    i0.ɵɵtemplate(1, JobDutiesResultsComponent_div_29_div_1_ul_6_li_1_Template, 2, 1, "li", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r49 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", eachDuty_r49 == null ? null : eachDuty_r49.subduty);
} }
function JobDutiesResultsComponent_div_29_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelementStart(2, "p-checkbox", 33);
    i0.ɵɵlistener("onChange", function JobDutiesResultsComponent_div_29_div_1_Template_p_checkbox_onChange_2_listener($event) { i0.ɵɵrestoreView(_r57); const eachDuty_r49 = ctx.$implicit; const ctx_r56 = i0.ɵɵnextContext(2); return ctx_r56.selectUnselectDuty($event, eachDuty_r49, "IMAGILITYLIB"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 34);
    i0.ɵɵelementStart(4, "p", 41);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, JobDutiesResultsComponent_div_29_div_1_ul_6_Template, 2, 1, "ul", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachDuty_r49 = ctx.$implicit;
    const i_r50 = ctx.index;
    const last_r51 = ctx.last;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1, last_r51));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("name", "imagilityLibDuty", i_r50, "");
    i0.ɵɵpropertyInterpolate1("inputId", "imagilityLibDuty-", i_r50, "");
    i0.ɵɵproperty("value", eachDuty_r49);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(eachDuty_r49.duty);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachDuty_r49.subduty && eachDuty_r49.subduty.length > 0);
} }
function JobDutiesResultsComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, JobDutiesResultsComponent_div_29_div_1_Template, 7, 8, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.dutiesArr);
} }
const _c2 = function (a0) { return { "all-duties-wrapper-wizard": a0 }; };
class JobDutiesResultsComponent {
    constructor(toastr, fb, listJobDutiesService, jobDutiesService, onetJobDuties, chatGptService) {
        this.toastr = toastr;
        this.fb = fb;
        this.listJobDutiesService = listJobDutiesService;
        this.jobDutiesService = jobDutiesService;
        this.onetJobDuties = onetJobDuties;
        this.chatGptService = chatGptService;
        this.activateView = new EventEmitter();
        this.disabledControls = false;
        this.categoryList = [];
        this.jobRoleOptions = [];
        this.dutiesArr = [];
        this.dutiesArrChatGPT = [];
        this.observableSubscription$ = new Subject();
        this.isListView = false;
        this.majorGroupCode = null;
        this.searchSubject = new Subject();
        this.onetDutyList = [];
        this.isListViewChatGPT = false;
        this.selectedDuties = [];
        this.isFormView = true;
        this.jobDutiesForm = new FormGroup({
            otherJobPosition: new FormControl(null),
            selectedCategory: new FormControl(null),
            jobRole: new FormControl(null)
        });
        this.searchSubject.pipe(debounceTime(500)).subscribe((value) => {
            this.onChangePosition(value);
        });
    }
    ngOnInit() {
        this.jobDutiesService
            .getJobCategoryList_ddl()
            .pipe(takeUntil(this.observableSubscription$), map((res) => {
            this.categoryList = res;
            if (this.inputData && this.jobDutiesForm && this.inputData.jsonInput && this.inputData.jsonInput.jobCategory) {
                const selectedCategory = this.categoryList.find((cat) => cat.jobCategory === this.inputData.jsonInput.jobCategory);
                if (selectedCategory) {
                    this.jobDutiesForm.get('selectedCategory').patchValue(selectedCategory);
                    return ({ event: { value: { id: selectedCategory[0].id } }, categoryResponse: res });
                }
            }
            return ({ event: null, categoryResponse: res });
        }), switchMap(({ event, categoryResponse }) => !!event ? this.jobDutiesService.getJobRolesList_ddl(event, this.inputData).pipe(tap(jobRoleResponse => {
            this.onJobRolesSuccessReponse(jobRoleResponse);
        })) : of('')))
            .subscribe();
        this.onLoadDutySubDuty();
    }
    ngOnChanges(changes) {
        if (changes.jobPositionTitle && changes.jobPositionTitle.currentValue) {
            this.searchPositiontitle = changes.jobPositionTitle.currentValue;
            this.searchSubject.next(this.searchPositiontitle);
        }
        else {
            this.getJobDescription();
        }
        if (changes.jobPositionTitle && changes.jobPositionTitle.currentValue) {
            this.searchText = changes.jobPositionTitle.currentValue;
            this.onChangeSearch(this.searchText);
        }
        else {
            this.getJobDescriptionChatGpt();
        }
    }
    getJobDescriptionChatGpt() {
        this.listJobDutiesService.getJobDescription$().subscribe((response) => {
            if (response.status === 200) {
                this.searchText = response === null || response === void 0 ? void 0 : response.data.jobTitle;
                if (this.searchText) {
                    this.onChangeSearch(this.searchText);
                }
            }
        });
    }
    onChangeSearch(val) {
        this.dutiesArr = [];
        if (val) {
            this.chatGptService.getChatGptDetails(val).pipe(takeUntil(this.observableSubscription$)).subscribe((resData) => {
                if (resData && resData.status === 200) {
                    if (resData && resData.data.chatGptResponseDTOList && resData.data.chatGptResponseDTOList.length > 0) {
                        this.dutiesArrChatGPT = [...resData.data.chatGptResponseDTOList];
                        this.dutiesArrChatGPT.forEach(e => {
                            e.type = 'CHATGPTLIB';
                        });
                        this.isListViewChatGPT = true;
                    }
                    else {
                        this.isListViewChatGPT = false;
                    }
                }
                else {
                    this.isListViewChatGPT = false;
                    CustomErrorToastComponent.showErrorToast(this.toastr, resData.message);
                }
            });
        }
    }
    addToList() {
        if (this.selectedDuties.length > 0) {
            this.listJobDutiesService.setDuties(this.selectedDuties);
            this.activateView.emit('dutiesCart');
            this.toastr.success('Duty added successfully.', 'Success');
        }
        else {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select duties first.');
        }
    }
    onChangeCategory(event) {
        this.jobDutiesService
            .getJobRolesList_ddl(event.value.id, this.inputData)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.onJobRolesSuccessReponse(response);
        });
    }
    onJobRolesSuccessReponse(response) {
        if (response) {
            this.jobRoleOptions = response.filter((role) => role.jobTitle !== "Other");
            // this.selectedJobPosition = this.parentForm.get('jobRole').value === 'Other' ? 'Other' : this.parentForm.get('jobRole').value;
            let selectedJobRole;
            if (this.inputData && this.jobDutiesForm && this.inputData.jsonInput && this.inputData.jsonInput.jobRole) {
                selectedJobRole = this.jobRoleOptions.find((role) => role.jobTitle === this.inputData.jsonInput.jobRole);
            }
            if (!!selectedJobRole) {
                this.jobDutiesForm.get('jobRole').patchValue(selectedJobRole.jobTitle);
            }
            else {
                this.jobDutiesForm.get('jobRole').patchValue(null);
            }
        }
    }
    populateJobDuties(input) {
        this.jobDutiesService
            .getJobRolesDuties(this.inputData.companyId, input.selectedJobPositionId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            if (data && data.jobDuty && data.jobDuty.length > 0) {
                this.dutiesArr = data.jobDuty.map(e => {
                    e.type = 'IMAGILITYLIB';
                    return e;
                });
                this.isFormView = false;
            }
            else {
                this.isFormView = true;
            }
        });
    }
    setPositionTitle({ value }) {
        sessionStorage.setItem("selectedJobRole", JSON.stringify(this.jobRoleOptions.find((item) => item.jobTitle == value)));
        if (value !== 'Other') {
            this.jobDutiesForm.controls['otherJobPosition'].setValue(null);
        }
    }
    saveJobRoleOrPopulateDuties() {
        const jobRole = this.jobDutiesForm.get('jobRole').value;
        this.populateJobDuties({
            selectedJobPosition: jobRole,
            customPositionTitle: this.jobDutiesForm.get('otherJobPosition').value,
            selectedJobPositionId: this.jobRoleOptions.find(x => x.jobTitle === jobRole).id
        });
    }
    onLoadDutySubDuty() {
        // this.onetDutyList = [];
        // this.onetDutyList = [{name: 'Others', id: 'other'}];
        // this.addOptionForm = this.jobDescriptionBuilder.group({
        //   addOption: [null, [Validators.required]],
        //   duty: [null],
        //   others: [null]
        // }); 
        this.listJobDutiesService.getJobDescription$().subscribe((response) => {
            var _a, _b, _c;
            if (response && response.status === 200) {
                const dutyPayload = {
                    petitionId: (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.petitionId,
                    pbPositionId: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.id
                };
                this.positionId = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.id;
                this.onetJobDuties.getDutyListItems(dutyPayload).pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    if (response && response.status === 200) {
                        this.onetDutyList = [{ name: 'Others', id: 'other' }, ...response.data];
                        let objectProperty = "name";
                        let objectToMove = "Others";
                        let index = this.onetDutyList.findIndex(obj => obj[objectProperty] === objectToMove);
                        if (index !== -1) {
                            let object = this.onetDutyList.splice(index, 1)[0];
                            this.onetDutyList.push(object);
                        }
                    }
                });
            }
        });
    }
    getJobDescription() {
        this.listJobDutiesService.getJobDescription$().subscribe((response) => {
            if (response.status === 200) {
                this.searchPositiontitle = response === null || response === void 0 ? void 0 : response.data.jobTitle;
                if (this.searchPositiontitle) {
                    this.searchSubject.next(this.searchPositiontitle);
                }
            }
        });
    }
    onChangePosition(val) {
        this.majorGroupCode = null;
        this.onetDutyList = [];
        this.isListView = false;
        if (val) {
            this.onetJobDuties.getMajorGroupCodes(this.inputData.visatype, val).pipe(takeUntil(this.observableSubscription$)).subscribe((groupCodeResponse) => {
                this.majourGroupCodeList = groupCodeResponse ? groupCodeResponse : [];
            });
        }
        else {
            this.majourGroupCodeList = [];
        }
    }
    handleMajorGroupCodeChange(event) {
        this.onetDutyList = [];
        if (event.value) {
            this.majorGroupCode = event.value;
            const payload = {
                "searchQuery": this.searchPositiontitle,
                "majorGroup": event.value
            };
            this.onetJobDuties.onetListItems(payload).pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                var _a;
                if (response.status === 200) {
                    //this.onetData = response.data;
                    this.onetDutyList = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.taskList;
                    this.isListView = true;
                }
                else {
                    this.isListView = false;
                }
            });
        }
        else {
            this.majorGroupCode = null;
            this.isListView = false;
        }
    }
    onSearchInput(event) {
        this.searchPositiontitle = event;
        this.searchSubject.next(event);
    }
    selectUnselectDuty(event, duty, type) {
        var _a, _b;
        switch (type) {
            case 'IMAGILITYLIB':
                if (event.checked) {
                    const dutyObj = { type, id: duty === null || duty === void 0 ? void 0 : duty.dutyId, name: duty === null || duty === void 0 ? void 0 : duty.duty, subJobDuty: ((_a = duty.subduty) === null || _a === void 0 ? void 0 : _a.length) ? duty.subduty.map((sd) => { return { id: sd.dutyId, name: sd.duty }; }) : [] };
                    this.selectedDuties.push(dutyObj);
                }
                else {
                    const itemIdex = this.selectedDuties.findIndex((x) => x.id === duty.dutyId && x.type === type);
                    if (itemIdex > -1) {
                        this.selectedDuties.splice(itemIdex, 1);
                    }
                }
                break;
            case 'CHATGPTLIB':
                if (event.checked) {
                    const dutyObj = { type, id: duty === null || duty === void 0 ? void 0 : duty.id, name: duty === null || duty === void 0 ? void 0 : duty.imagilityDuty, subJobDuty: ((_b = duty.imagilitySubDuties) === null || _b === void 0 ? void 0 : _b.length) ? duty.imagilitySubDuties.map((sd) => { return { id: null, name: sd }; }) : [] };
                    this.selectedDuties.push(dutyObj);
                }
                else {
                    const itemIdex = this.selectedDuties.findIndex((x) => x.id === (duty === null || duty === void 0 ? void 0 : duty.id) && x.type === type);
                    if (itemIdex > -1) {
                        this.selectedDuties.splice(itemIdex, 1);
                    }
                }
                break;
            case 'ONETLIB':
                if (event.checked) {
                    const dutyObj = { type, id: null, name: duty, subJobDuty: [] };
                    this.selectedDuties.push(dutyObj);
                }
                else {
                    const itemIdex = this.selectedDuties.findIndex((x) => x.name === duty && x.type === type);
                    if (itemIdex > -1) {
                        this.selectedDuties.splice(itemIdex, 1);
                    }
                }
                break;
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
JobDutiesResultsComponent.ɵfac = function JobDutiesResultsComponent_Factory(t) { return new (t || JobDutiesResultsComponent)(i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i2$1.FormBuilder), i0.ɵɵdirectiveInject(ListJobDutiesService), i0.ɵɵdirectiveInject(ImagilityJobDutiesService), i0.ɵɵdirectiveInject(OnetJobDuties), i0.ɵɵdirectiveInject(ChatGptDutiesService)); };
JobDutiesResultsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: JobDutiesResultsComponent, selectors: [["job-duties-results"]], inputs: { inputData: "inputData", isWizard: "isWizard", disabledControls: "disabledControls", jobPositionTitle: "jobPositionTitle" }, outputs: { activateView: "activateView" }, features: [i0.ɵɵNgOnChangesFeature], decls: 34, vars: 15, consts: [[1, "all-duties-wrapper", 3, "ngClass"], [1, "row"], [1, "col-md-12", "pl-0"], [1, "duties-results-heading"], [1, "row", "duties-results-header"], [1, "col-4", "text-center", "onet-img"], ["src", "assets/onet.png", "alt", ""], [1, "col-4", "text-center", "chat-gpt-img"], ["src", "assets/chatGptIcon.png", "alt", ""], [1, "col-4", "text-center", "imm-library-img"], ["src", "assets/weblogo.png", "alt", ""], [1, "row", "duties-results-content"], [1, "col-4", "duties-results-content-onet", "bg-right"], ["class", "row", 4, "ngIf"], ["id", "chatGpt", 1, "col-4", "duties-results-content-chat-gpt", "bg-right"], [1, "col-4", "duties-results-content-library", "bg-right"], [3, "formGroup"], ["class", "library-title pt-2", 4, "ngIf"], [1, "row", "duties-results-footer"], [1, "col-md-9", "d-flex"], [1, "col-md-3", "d-flex", "justify-content-center"], ["pButton", "", "type", "button", "label", "ADD TO LIST", 1, "my-2", "add-to-list-btn", 3, "disabled", "click"], [1, "col-12", "py-2", "px-0"], [1, "label-cls", "row"], ["name", "positionTitle", "type", "text", "pInputText", "", 1, "im-input", "w-100", 3, "ngModel", "ngModelChange", "input"], ["appendTo", "body", "name", "selectedMajorGroupCode", "optionValue", "majorGroup", "optionLabel", "majorGroupName", "placeholder", "Select Group Code", 1, "w-100", 3, "options", "filter", "ngModel", "showClear", "ngModelChange", "onChange"], ["pTemplate", "item"], [1, "p-d-flex", "p-ai-center"], [1, "back-button", "back-btn-white-bg", "pl-0", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-chevron-circle-left"], ["class", "col-12 eachDuty px-0 py-1 d-flex", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "col-12", "eachDuty", "px-0", "py-1", "d-flex", 3, "ngClass"], [1, "w-10"], ["binary", "true", 3, "name", "value", "inputId", "onChange"], [1, "w-90"], [1, "dutyText"], [1, "col-12", "p-3", "searchPortion"], ["appearance", "fill", 1, "w-100"], ["matInput", "", "placeholder", "Message ChatGPT", 3, "ngModel", "ngModelChange"], ["class", "fa fa-search", "matSuffix", "", "aria-hidden", "true", 3, "click", 4, "ngIf"], ["matSuffix", "", "aria-hidden", "true", 1, "fa", "fa-search", 3, "click"], [1, "dutyText", "mb-1"], ["class", "sub-duties pl-4", 4, "ngIf"], [1, "sub-duties", "pl-4"], [4, "ngFor", "ngForOf"], [1, "library-title", "pt-2"], [1, "col-md-12", "pl-0", "pb-2"], [1, "label-cls"], ["placeholder", "Select Category", "formControlName", "selectedCategory", "appendTo", "body", "optionLabel", "jobCategory", 3, "options", "disabled", "onChange"], [1, "col-md-12", "pl-0", "processing-dropdown", "pb-2"], ["id", "jobRolesId", "appendTo", "body", "optionLabel", "jobTitle", "optionValue", "jobTitle", "formControlName", "jobRole", "placeholder", "select", 3, "options", "filter", "disabled", "onChange"], [1, "col-md-12", "pl-0", "displayFlex", "align-bottom"], ["type", "button", 1, "im-btn", "im-btn-outline-primary", "button_whitebg", 3, "click"]], template: function JobDutiesResultsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5", 3);
        i0.ɵɵtext(4, "Copy & Paste/ Drag and Drop results generated from ONET, Chat GPT or library to customize your options");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelement(7, "img", 6);
        i0.ɵɵtext(8, " ONET OnLine ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelement(10, "img", 8);
        i0.ɵɵtext(11, " Chat GPT ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelement(13, "img", 10);
        i0.ɵɵtext(14, " Library ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 11);
        i0.ɵɵelementStart(16, "div", 12);
        i0.ɵɵtemplate(17, JobDutiesResultsComponent_div_17_Template, 10, 5, "div", 13);
        i0.ɵɵtemplate(18, JobDutiesResultsComponent_div_18_Template, 4, 0, "div", 13);
        i0.ɵɵtemplate(19, JobDutiesResultsComponent_div_19_Template, 2, 1, "div", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 14);
        i0.ɵɵtemplate(21, JobDutiesResultsComponent_div_21_Template, 5, 2, "div", 13);
        i0.ɵɵtemplate(22, JobDutiesResultsComponent_div_22_Template, 4, 0, "div", 13);
        i0.ɵɵtemplate(23, JobDutiesResultsComponent_div_23_Template, 2, 1, "div", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 15);
        i0.ɵɵelementStart(25, "form", 16);
        i0.ɵɵtemplate(26, JobDutiesResultsComponent_p_26_Template, 2, 0, "p", 17);
        i0.ɵɵtemplate(27, JobDutiesResultsComponent_div_27_Template, 12, 8, "div", 13);
        i0.ɵɵtemplate(28, JobDutiesResultsComponent_div_28_Template, 4, 0, "div", 13);
        i0.ɵɵtemplate(29, JobDutiesResultsComponent_div_29_Template, 2, 1, "div", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 18);
        i0.ɵɵelement(31, "div", 19);
        i0.ɵɵelementStart(32, "div", 20);
        i0.ɵɵelementStart(33, "button", 21);
        i0.ɵɵlistener("click", function JobDutiesResultsComponent_Template_button_click_33_listener() { return ctx.addToList(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2, ctx.isWizard));
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngIf", !ctx.isListView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isListView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isListView);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isListViewChatGPT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isListViewChatGPT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isListViewChatGPT);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.jobDutiesForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isFormView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isFormView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isFormView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isFormView);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", !ctx.selectedDuties.length || ctx.disabledControls);
    } }, directives: [i7.NgClass, i7.NgIf, i2$1.ɵangular_packages_forms_forms_ba, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i8$1.ButtonDirective, i2$1.DefaultValueAccessor, i6$1.InputText, i2$1.NgControlStatus, i2$1.NgModel, i6.Dropdown, i11.PrimeTemplate, i7.NgForOf, i12$1.Checkbox, i6$2.MatFormField, i7$1.MatInput, i6$2.MatSuffix, i2$1.FormControlName], styles: [".duties-results-heading[_ngcontent-%COMP%]{font:normal normal 700 18px/25px Source Sans Pro}.duties-results-header[_ngcontent-%COMP%]{align-items:center;background-color:#e0f0f7;min-height:4.5rem}.duties-results-header[_ngcontent-%COMP%]   .text-center[_ngcontent-%COMP%]{font:normal normal 700 16px/17px Source Sans Pro;color:#4d4f5c}.duties-results-header[_ngcontent-%COMP%]   .text-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font:normal normal normal 12px/17px Source Sans Pro;color:#4d4f5c}.duties-results-header[_ngcontent-%COMP%]   .chat-gpt-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], .duties-results-header[_ngcontent-%COMP%]   .onet-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:45px;margin-right:5px}.duties-results-header[_ngcontent-%COMP%]   .imm-library-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:90px;margin-top:-10px;margin-right:10px}.duties-results-footer[_ngcontent-%COMP%]{background-color:#e0f0f7;min-height:4rem;align-items:right}.duties-results-footer[_ngcontent-%COMP%]   .add-to-list-btn[_ngcontent-%COMP%]{height:2.7rem}.warn-caption[_ngcontent-%COMP%]{font-size:13px;color:#b46800!important}.warn-caption[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700}.bg-right[_ngcontent-%COMP%]{border-right:1px solid #c3d0de}.duties-results-content-chat-gpt[_ngcontent-%COMP%], .duties-results-content-customize[_ngcontent-%COMP%], .duties-results-content-library[_ngcontent-%COMP%], .duties-results-content-onet[_ngcontent-%COMP%]{max-height:390px;min-height:300px;overflow-y:auto}.w-10[_ngcontent-%COMP%]{width:10%}.w-90[_ngcontent-%COMP%]{width:90%}.searchPortion[_ngcontent-%COMP%]{text-align:center}.searchPortion[_ngcontent-%COMP%]   i.fa.fa-search[_ngcontent-%COMP%]:hover{color:#1ca0da;cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDutiesResultsComponent, [{
        type: Component,
        args: [{
                selector: 'job-duties-results',
                templateUrl: 'job-duties-results.component.html',
                styleUrls: ['job-duties-results.component.scss']
            }]
    }], function () { return [{ type: i4.ToastrService }, { type: i2$1.FormBuilder }, { type: ListJobDutiesService }, { type: ImagilityJobDutiesService }, { type: OnetJobDuties }, { type: ChatGptDutiesService }]; }, { inputData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], activateView: [{
            type: Output
        }], disabledControls: [{
            type: Input
        }], jobPositionTitle: [{
            type: Input
        }] }); })();

function ListJobDutiesComponent_lib_imagility_job_duties_32_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-imagility-job-duties", 18);
    i0.ɵɵlistener("activateView", function ListJobDutiesComponent_lib_imagility_job_duties_32_Template_lib_imagility_job_duties_activateView_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.activateView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputData", ctx_r0.inputData);
} }
function ListJobDutiesComponent_lib_onet_job_duties_33_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-onet-job-duties", 19);
    i0.ɵɵlistener("activateView", function ListJobDutiesComponent_lib_onet_job_duties_33_Template_lib_onet_job_duties_activateView_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.activateView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputData", ctx_r1.inputData)("jobPositionTitle", ctx_r1.positionTitle);
} }
function ListJobDutiesComponent_lib_chatgpt_duties_34_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-chatgpt-duties", 19);
    i0.ɵɵlistener("activateView", function ListJobDutiesComponent_lib_chatgpt_duties_34_Template_lib_chatgpt_duties_activateView_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.activateView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputData", ctx_r2.inputData)("jobPositionTitle", ctx_r2.positionTitle);
} }
function ListJobDutiesComponent_lib_create_duties_35_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-create-duties", 18);
    i0.ɵɵlistener("activateView", function ListJobDutiesComponent_lib_create_duties_35_Template_lib_create_duties_activateView_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.activateView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputData", ctx_r3.inputData);
} }
function ListJobDutiesComponent_lib_duties_cart_36_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-duties-cart", 20);
    i0.ɵɵlistener("activateView", function ListJobDutiesComponent_lib_duties_cart_36_Template_lib_duties_cart_activateView_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.activateView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSave", ctx_r4.isSave)("isWizard", ctx_r4.isWizard)("inputData", ctx_r4.inputData);
} }
function ListJobDutiesComponent_job_duties_results_37_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "job-duties-results", 21);
    i0.ɵɵlistener("activateView", function ListJobDutiesComponent_job_duties_results_37_Template_job_duties_results_activateView_0_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.activateView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isWizard", ctx_r5.isWizard)("jobPositionTitle", ctx_r5.positionTitle)("inputData", ctx_r5.inputData);
} }
function ListJobDutiesComponent_div_38_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function ListJobDutiesComponent_div_38_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.saveContinue(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r19.disableSave);
} }
function ListJobDutiesComponent_div_38_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function ListJobDutiesComponent_div_38_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.saveContinue(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r20.disableSave);
} }
function ListJobDutiesComponent_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "div", 22);
    i0.ɵɵelementStart(2, "div", 23);
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵtemplate(4, ListJobDutiesComponent_div_38_button_4_Template, 1, 1, "button", 25);
    i0.ɵɵtemplate(5, ListJobDutiesComponent_div_38_button_5_Template, 1, 1, "button", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r6.disabledControls ? "isDisabledCls" : "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r6.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.isWizard);
} }
const _c0 = function (a0) { return { "active": a0 }; };
class ListJobDutiesComponent {
    constructor(listJobDutiesService, toastr, store, appServicesLibraryService) {
        this.listJobDutiesService = listJobDutiesService;
        this.toastr = toastr;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.dutiesCount = 0;
        this.allViews = ['imagilityLibrary', 'onet', 'chatGpt', 'createYourOwn', 'dutiesCart', 'allResults'];
        this.activeView = 'imagilityLibrary';
        this.observableSubscription$ = new Subject();
        this.disableSave = true;
        this.duties = [];
        this.positionId = 0;
        this.disabledControls = false;
    }
    ngOnInit() {
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            if (data && data.id) {
                this.stepDetails = data;
                this.toggleControlsStatus();
            }
        });
        this
            .listJobDutiesService
            .getJobDescription(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, false)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.listJobDutiesService.setJobDescription$(response);
            if (response && response.data && response.data.duties) {
                this.dutiesCount = response.data.duties.length;
                this.listJobDutiesService.setDuties(response.data.duties, false);
            }
            this.activeView = 'dutiesCart';
        });
        this.listJobDutiesService.getDuties().subscribe(val => {
            this.duties = val;
            this.dutiesCount = val.length;
        });
        this.listJobDutiesService.getJobDescription$().subscribe((response) => {
            if (response && response.data) {
                this.positionId = response.data.id;
                this.disableSave = false;
            }
            else {
                this.disableSave = true;
            }
        });
    }
    ngOnChanges(changes) {
        if (changes.jobDescription && changes.jobDescription.currentValue) {
            this.positionTitle = changes.jobDescription.currentValue;
        }
    }
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    }
    /**
     * Activate respective view, take reference of the variable 'allViews'
     */
    activateView(viewName) {
        this.activeView = viewName;
    }
    // onGetduties(event:any) {
    //   if(event.id) {
    //     this.disableSave = false;
    //   }
    //   this._payload = event;
    // }
    saveContinue() {
        var _a;
        (_a = this.duties) === null || _a === void 0 ? void 0 : _a.forEach((el) => {
            var _a;
            el.id = null;
            (_a = el.subJobDuty) === null || _a === void 0 ? void 0 : _a.forEach(val => {
                val.id = null;
            });
        });
        let _payload = {
            duties: this.duties,
            id: this.positionId
        };
        this.listJobDutiesService.saveOnetDutySubDuty(this.inputData, _payload).pipe(tap(response => {
            if (response && response.status == 200) {
                this.toastr.success('Duties saved succesfully.', 'Success');
            }
        }), switchMap(response => this
            .listJobDutiesService
            .getJobDescription(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, false)
            .pipe(takeUntil(this.observableSubscription$), map(positionDetailsResponse => ({ response, positionDetailsResponse }))))).subscribe(({ response, positionDetailsResponse }) => {
            this.listJobDutiesService.setJobDescription$(positionDetailsResponse);
            if (response && response.data && response.data.duties) {
                this.dutiesCount = response.data.duties.length;
                this.listJobDutiesService.setDuties(response.data.duties, false);
            }
            this.activeView = 'dutiesCart';
        });
    }
    ngOnDestroy() {
        this.listJobDutiesService.setDuties([], false);
        this.listJobDutiesService.setJobDescription$(null);
        this.observableSubscription$.complete();
    }
}
ListJobDutiesComponent.ɵfac = function ListJobDutiesComponent_Factory(t) { return new (t || ListJobDutiesComponent)(i0.ɵɵdirectiveInject(ListJobDutiesService), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4$1.AppServicesLibraryService)); };
ListJobDutiesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ListJobDutiesComponent, selectors: [["list-job-duties"]], inputs: { jobDescription: "jobDescription", inputData: "inputData", isSave: "isSave", isWizard: "isWizard" }, features: [i0.ɵɵNgOnChangesFeature], decls: 39, vars: 30, consts: [[1, "list-job-duties-wrapper", 3, "ngClass"], [1, "row", 3, "ngClass"], [1, "col-md-12"], [1, "normal-txt"], [1, "job-duties-tabs-wrapper"], ["type", "button", 1, "job-duties-tab-btn", 3, "ngClass", "click"], ["src", "assets/imagility-calendar.png", "alt", ""], ["src", "assets/onet.png", "alt", ""], ["src", "assets/chatGptIcon.png", "alt", ""], ["layout", "vertical"], ["type", "button", 1, "border-btn", "duties-cart-btn", 3, "ngClass", "click"], [1, "badge"], [1, "col-md-12", 3, "ngSwitch"], [3, "inputData", "activateView", 4, "ngSwitchCase"], [3, "inputData", "jobPositionTitle", "activateView", 4, "ngSwitchCase"], [3, "isSave", "isWizard", "inputData", "activateView", 4, "ngSwitchCase"], [3, "isWizard", "jobPositionTitle", "inputData", "activateView", 4, "ngSwitchCase"], ["class", "row", 3, "ngClass", 4, "ngIf"], [3, "inputData", "activateView"], [3, "inputData", "jobPositionTitle", "activateView"], [3, "isSave", "isWizard", "inputData", "activateView"], [3, "isWizard", "jobPositionTitle", "inputData", "activateView"], [1, "col-md-9"], [1, "col-md-3"], [1, "col-md-12", "save-btn", "pb-2", "textRight", "pl-0", "pr-0"], ["class", "mb-3 mt-5 pull-right", "pButton", "", "type", "button", "label", "Save & Continue", 3, "disabled", "click", 4, "ngIf"], ["class", "mb-3 mt-5 pull-right", "pButton", "", "type", "button", "label", "Save", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "type", "button", "label", "Save & Continue", 1, "mb-3", "mt-5", "pull-right", 3, "disabled", "click"], ["pButton", "", "type", "button", "label", "Save", 1, "mb-3", "mt-5", "pull-right", 3, "disabled", "click"]], template: function ListJobDutiesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4, "How do you want to create duties and sub duties?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "p", 3);
        i0.ɵɵtext(7, "View results by: ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "button", 5);
        i0.ɵɵlistener("click", function ListJobDutiesComponent_Template_button_click_8_listener() { return ctx.activateView("imagilityLibrary"); });
        i0.ɵɵelement(9, "img", 6);
        i0.ɵɵtext(10, " Imagility Library ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "button", 5);
        i0.ɵɵlistener("click", function ListJobDutiesComponent_Template_button_click_11_listener() { return ctx.activateView("onet"); });
        i0.ɵɵelement(12, "img", 7);
        i0.ɵɵtext(13, " ONET ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "button", 5);
        i0.ɵɵlistener("click", function ListJobDutiesComponent_Template_button_click_14_listener() { return ctx.activateView("chatGpt"); });
        i0.ɵɵelement(15, "img", 8);
        i0.ɵɵtext(16, " Chat GPT ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "p", 3);
        i0.ɵɵtext(18, "OR");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "button", 5);
        i0.ɵɵlistener("click", function ListJobDutiesComponent_Template_button_click_19_listener() { return ctx.activateView("createYourOwn"); });
        i0.ɵɵtext(20, " Create your own ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "p", 3);
        i0.ɵɵelement(22, "p-divider", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "button", 5);
        i0.ɵɵlistener("click", function ListJobDutiesComponent_Template_button_click_23_listener() { return ctx.activateView("allResults"); });
        i0.ɵɵtext(24, " View All Results ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "button", 10);
        i0.ɵɵlistener("click", function ListJobDutiesComponent_Template_button_click_25_listener() { return ctx.activateView("dutiesCart"); });
        i0.ɵɵelementStart(26, "span", 11);
        i0.ɵɵelementStart(27, "span");
        i0.ɵɵtext(28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(29, "List of Duties Added ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 1);
        i0.ɵɵelementStart(31, "div", 12);
        i0.ɵɵtemplate(32, ListJobDutiesComponent_lib_imagility_job_duties_32_Template, 1, 1, "lib-imagility-job-duties", 13);
        i0.ɵɵtemplate(33, ListJobDutiesComponent_lib_onet_job_duties_33_Template, 1, 2, "lib-onet-job-duties", 14);
        i0.ɵɵtemplate(34, ListJobDutiesComponent_lib_chatgpt_duties_34_Template, 1, 2, "lib-chatgpt-duties", 14);
        i0.ɵɵtemplate(35, ListJobDutiesComponent_lib_create_duties_35_Template, 1, 1, "lib-create-duties", 13);
        i0.ɵɵtemplate(36, ListJobDutiesComponent_lib_duties_cart_36_Template, 1, 3, "lib-duties-cart", 15);
        i0.ɵɵtemplate(37, ListJobDutiesComponent_job_duties_results_37_Template, 1, 3, "job-duties-results", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(38, ListJobDutiesComponent_div_38_Template, 6, 3, "div", 17);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.disabledControls ? "notAllowed" : "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.disabledControls ? "isDisabledCls" : "");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0, ctx.activeView == ctx.allViews[0]));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c0, ctx.activeView == ctx.allViews[1]));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c0, ctx.activeView == ctx.allViews[2]));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c0, ctx.activeView == ctx.allViews[3]));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c0, ctx.activeView == ctx.allViews[5]));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c0, ctx.activeView == ctx.allViews[4]));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.dutiesCount);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.disabledControls ? "isDisabledCls" : "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.activeView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "imagilityLibrary");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "onet");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "chatGpt");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "createYourOwn");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "dutiesCart");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "allResults");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSave);
    } }, directives: [i7.NgClass, i6$4.Divider, i7.NgSwitch, i7.NgSwitchCase, i7.NgIf, ImagilityJobDutiesComponent, OnetJobDutiesComponent, ChatgptDutiesComponent, CreateDutiesComponent, DutiesCartComponent, JobDutiesResultsComponent, i8$1.ButtonDirective], styles: ["[_nghost-%COMP%]{width:100%}.normal-txt[_ngcontent-%COMP%]{display:inline-block;font-weight:700;font-size:14px}.job-duties-tab-btn[_ngcontent-%COMP%]{border:1px solid #061058;border-radius:50px;padding:6px 16px;background-color:#fff;color:#061058;margin-left:6px;margin-right:6px;font-size:14px;box-shadow:2px 2px 10px 0 #a8a8a8}.job-duties-tab-btn.active[_ngcontent-%COMP%]{background-color:#1ca0da;color:#fff;border:none}.job-duties-tab-btn[_ngcontent-%COMP%]:active, .job-duties-tab-btn[_ngcontent-%COMP%]:focus, .job-duties-tab-btn[_ngcontent-%COMP%]:hover{border:1px solid #061058;box-shadow:none;-moz-box-shadow:none;-webkit-box-shadow:none}.job-duties-tab-btn.selected[_ngcontent-%COMP%]{background-color:#1ca0da;color:#333}  .duties-cart-btn>button{border:1px solid #061058;color:#6b7f96;background-color:#fff;font-weight:700}.job-duties-tab-btn[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:20px;height:20px}.border-btn[_ngcontent-%COMP%]{border:1px solid #1ca0da;background:#fff;color:#1ca0da}.duties-cart-btn[_ngcontent-%COMP%]{padding:8px 20px;border-radius:6px;border:1px solid #1ca0da;color:#6b7f96;background-color:#fff;float:right}.duties-cart-btn[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#fff;background-color:#1ca0da;display:inline-block;padding:2px 10px;border-radius:50%;width:28px;height:28px;margin-right:10px;position:relative;vertical-align:middle}.duties-cart-btn[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.library-title[_ngcontent-%COMP%]{font-size:16px;font-weight:700}.notAllowed[_ngcontent-%COMP%]{cursor:not-allowed}.isDisabledCls[_ngcontent-%COMP%]{pointer-events:none;opacity:.7}.wizardSave[_ngcontent-%COMP%]{position:absolute;right:0;top:-56px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListJobDutiesComponent, [{
        type: Component,
        args: [{
                selector: 'list-job-duties',
                templateUrl: 'list-job-duties.component.html',
                styleUrls: ['list-job-duties.component.scss']
            }]
    }], function () { return [{ type: ListJobDutiesService }, { type: i4.ToastrService }, { type: i3.Store }, { type: i4$1.AppServicesLibraryService }]; }, { jobDescription: [{
            type: Input
        }], inputData: [{
            type: Input
        }], isSave: [{
            type: Input
        }], isWizard: [{
            type: Input
        }] }); })();

class ListJobDutiesModule {
}
ListJobDutiesModule.ɵfac = function ListJobDutiesModule_Factory(t) { return new (t || ListJobDutiesModule)(); };
ListJobDutiesModule.ɵmod = i0.ɵɵdefineNgModule({ type: ListJobDutiesModule });
ListJobDutiesModule.ɵinj = i0.ɵɵdefineInjector({ providers: [], imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            MatListModule,
            MatInputModule,
            MatFormFieldModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ListJobDutiesModule, { declarations: [ListJobDutiesComponent,
        OnetJobDutiesComponent,
        ImagilityJobDutiesComponent,
        DutiesCartComponent,
        CreateDutiesComponent,
        ChatgptDutiesComponent,
        JobDutiesResultsComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        MatListModule,
        MatInputModule,
        MatFormFieldModule], exports: [ListJobDutiesComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListJobDutiesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ListJobDutiesComponent,
                    OnetJobDutiesComponent,
                    ImagilityJobDutiesComponent,
                    DutiesCartComponent,
                    CreateDutiesComponent,
                    ChatgptDutiesComponent,
                    JobDutiesResultsComponent
                ],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatListModule,
                    MatInputModule,
                    MatFormFieldModule
                ],
                exports: [ListJobDutiesComponent],
                providers: []
            }]
    }], null, null); })();

/*
 * Public API Surface of list-job-duties
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ListJobDutiesComponent, ListJobDutiesModule, ListJobDutiesService };
//# sourceMappingURL=list-job-duties.js.map
